// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/agent.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Subject } from "./identity_pb.js";
import { ServiceSpec } from "./environment_automation_pb.js";

/**
 * AgentMode defines the operational mode of an agent
 *
 * @generated from enum gitpod.v1.AgentMode
 */
export enum AgentMode {
  /**
   * Default execution mode - standard agent behavior
   *
   * @generated from enum value: AGENT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Execution mode - agent performs tasks and makes changes
   *
   * @generated from enum value: AGENT_MODE_EXECUTION = 1;
   */
  EXECUTION = 1,

  /**
   * Planning mode - agent focuses on analysis and planning
   *
   * @generated from enum value: AGENT_MODE_PLANNING = 2;
   */
  PLANNING = 2,

  /**
   * Ralph mode - autonomous planning and implementation mode
   *
   * @generated from enum value: AGENT_MODE_RALPH = 3;
   */
  RALPH = 3,

  /**
   * Spec mode - planning phase followed by interactive implementation
   *
   * @generated from enum value: AGENT_MODE_SPEC = 4;
   */
  SPEC = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentMode)
proto3.util.setEnumType(AgentMode, "gitpod.v1.AgentMode", [
  { no: 0, name: "AGENT_MODE_UNSPECIFIED" },
  { no: 1, name: "AGENT_MODE_EXECUTION" },
  { no: 2, name: "AGENT_MODE_PLANNING" },
  { no: 3, name: "AGENT_MODE_RALPH" },
  { no: 4, name: "AGENT_MODE_SPEC" },
]);

/**
 * @generated from enum gitpod.v1.SupportedModel
 */
export enum SupportedModel {
  /**
   * @generated from enum value: SUPPORTED_MODEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_5 = 1;
   */
  SONNET_3_5 = 1,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7 = 2;
   */
  SONNET_3_7 = 2,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_3_7_EXTENDED = 3;
   */
  SONNET_3_7_EXTENDED = 3,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4 = 4;
   */
  SONNET_4 = 4,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_EXTENDED = 5;
   */
  SONNET_4_EXTENDED = 5,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_5 = 8;
   */
  SONNET_4_5 = 8,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_5_EXTENDED = 9;
   */
  SONNET_4_5_EXTENDED = 9,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_6 = 18;
   */
  SONNET_4_6 = 18,

  /**
   * @generated from enum value: SUPPORTED_MODEL_SONNET_4_6_EXTENDED = 19;
   */
  SONNET_4_6_EXTENDED = 19,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4 = 6;
   */
  OPUS_4 = 6,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_EXTENDED = 7;
   */
  OPUS_4_EXTENDED = 7,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_5 = 14;
   */
  OPUS_4_5 = 14,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_5_EXTENDED = 15;
   */
  OPUS_4_5_EXTENDED = 15,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_6 = 16;
   */
  OPUS_4_6 = 16,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPUS_4_6_EXTENDED = 17;
   */
  OPUS_4_6_EXTENDED = 17,

  /**
   * @generated from enum value: SUPPORTED_MODEL_HAIKU_4_5 = 21;
   */
  HAIKU_4_5 = 21,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O = 10;
   */
  OPENAI_4O = 10,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_4O_MINI = 11;
   */
  OPENAI_4O_MINI = 11,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1 = 12;
   */
  OPENAI_O1 = 12,

  /**
   * @generated from enum value: SUPPORTED_MODEL_OPENAI_O1_MINI = 13;
   */
  OPENAI_O1_MINI = 13,
}
// Retrieve enum metadata with: proto3.getEnumType(SupportedModel)
proto3.util.setEnumType(SupportedModel, "gitpod.v1.SupportedModel", [
  { no: 0, name: "SUPPORTED_MODEL_UNSPECIFIED" },
  { no: 1, name: "SUPPORTED_MODEL_SONNET_3_5" },
  { no: 2, name: "SUPPORTED_MODEL_SONNET_3_7" },
  { no: 3, name: "SUPPORTED_MODEL_SONNET_3_7_EXTENDED" },
  { no: 4, name: "SUPPORTED_MODEL_SONNET_4" },
  { no: 5, name: "SUPPORTED_MODEL_SONNET_4_EXTENDED" },
  { no: 8, name: "SUPPORTED_MODEL_SONNET_4_5" },
  { no: 9, name: "SUPPORTED_MODEL_SONNET_4_5_EXTENDED" },
  { no: 18, name: "SUPPORTED_MODEL_SONNET_4_6" },
  { no: 19, name: "SUPPORTED_MODEL_SONNET_4_6_EXTENDED" },
  { no: 6, name: "SUPPORTED_MODEL_OPUS_4" },
  { no: 7, name: "SUPPORTED_MODEL_OPUS_4_EXTENDED" },
  { no: 14, name: "SUPPORTED_MODEL_OPUS_4_5" },
  { no: 15, name: "SUPPORTED_MODEL_OPUS_4_5_EXTENDED" },
  { no: 16, name: "SUPPORTED_MODEL_OPUS_4_6" },
  { no: 17, name: "SUPPORTED_MODEL_OPUS_4_6_EXTENDED" },
  { no: 21, name: "SUPPORTED_MODEL_HAIKU_4_5" },
  { no: 10, name: "SUPPORTED_MODEL_OPENAI_4O" },
  { no: 11, name: "SUPPORTED_MODEL_OPENAI_4O_MINI" },
  { no: 12, name: "SUPPORTED_MODEL_OPENAI_O1" },
  { no: 13, name: "SUPPORTED_MODEL_OPENAI_O1_MINI" },
]);

/**
 * LLMIntegrationPhase represents the current status/phase of an LLM integration
 *
 * @generated from enum gitpod.v1.LLMIntegrationPhase
 */
export enum LLMIntegrationPhase {
  /**
   * @generated from enum value: LLM_INTEGRATION_PHASE_UNSPECIFIED = 0;
   */
  LLM_INTEGRATION_PHASE_UNSPECIFIED = 0,

  /**
   * The integration can be used to make requests
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_AVAILABLE = 1;
   */
  LLM_INTEGRATION_PHASE_AVAILABLE = 1,

  /**
   * The integration cannot be used, likely due to insufficient funds
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_UNAVAILABLE = 2;
   */
  LLM_INTEGRATION_PHASE_UNAVAILABLE = 2,

  /**
   * The integration cannot be used because the user disabled it
   *
   * @generated from enum value: LLM_INTEGRATION_PHASE_DISABLED = 3;
   */
  LLM_INTEGRATION_PHASE_DISABLED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(LLMIntegrationPhase)
proto3.util.setEnumType(LLMIntegrationPhase, "gitpod.v1.LLMIntegrationPhase", [
  { no: 0, name: "LLM_INTEGRATION_PHASE_UNSPECIFIED" },
  { no: 1, name: "LLM_INTEGRATION_PHASE_AVAILABLE" },
  { no: 2, name: "LLM_INTEGRATION_PHASE_UNAVAILABLE" },
  { no: 3, name: "LLM_INTEGRATION_PHASE_DISABLED" },
]);

/**
 * AgentExecutionFailureReason represents the reason why an agent execution failed
 *
 * @generated from enum gitpod.v1.AgentExecutionFailureReason
 */
export enum AgentExecutionFailureReason {
  /**
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The agent execution failed due to environment issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * The agent execution failed due to service issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_SERVICE = 2;
   */
  SERVICE = 2,

  /**
   * The agent execution failed due to LLM integration issues
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_LLM_INTEGRATION = 3;
   */
  LLM_INTEGRATION = 3,

  /**
   * Deprecated: The agent execution failed due to internal errors
   * Use AGENT_EXECUTION_FAILURE_REASON_AGENT_EXECUTION instead
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_INTERNAL = 4;
   */
  INTERNAL = 4,

  /**
   * The agent execution failed due to agent execution errors
   *
   * @generated from enum value: AGENT_EXECUTION_FAILURE_REASON_AGENT_EXECUTION = 5;
   */
  AGENT_EXECUTION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentExecutionFailureReason)
proto3.util.setEnumType(AgentExecutionFailureReason, "gitpod.v1.AgentExecutionFailureReason", [
  { no: 0, name: "AGENT_EXECUTION_FAILURE_REASON_UNSPECIFIED" },
  { no: 1, name: "AGENT_EXECUTION_FAILURE_REASON_ENVIRONMENT" },
  { no: 2, name: "AGENT_EXECUTION_FAILURE_REASON_SERVICE" },
  { no: 3, name: "AGENT_EXECUTION_FAILURE_REASON_LLM_INTEGRATION" },
  { no: 4, name: "AGENT_EXECUTION_FAILURE_REASON_INTERNAL" },
  { no: 5, name: "AGENT_EXECUTION_FAILURE_REASON_AGENT_EXECUTION" },
]);

/**
 * AgentExecutionRole represents the role of an agent execution
 *
 * @generated from enum gitpod.v1.AgentExecutionRole
 */
export enum AgentExecutionRole {
  /**
   * @generated from enum value: AGENT_EXECUTION_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default role for agent executions
   *
   * @generated from enum value: AGENT_EXECUTION_ROLE_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * Workflow role for agent executions that are part of a workflow
   *
   * @generated from enum value: AGENT_EXECUTION_ROLE_WORKFLOW = 2;
   */
  WORKFLOW = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentExecutionRole)
proto3.util.setEnumType(AgentExecutionRole, "gitpod.v1.AgentExecutionRole", [
  { no: 0, name: "AGENT_EXECUTION_ROLE_UNSPECIFIED" },
  { no: 1, name: "AGENT_EXECUTION_ROLE_DEFAULT" },
  { no: 2, name: "AGENT_EXECUTION_ROLE_WORKFLOW" },
]);

/**
 * MCPIntegrationPhase represents the status of an MCP integration connection
 *
 * @generated from enum gitpod.v1.MCPIntegrationPhase
 */
export enum MCPIntegrationPhase {
  /**
   * @generated from enum value: MCP_INTEGRATION_PHASE_UNSPECIFIED = 0;
   */
  MCP_INTEGRATION_PHASE_UNSPECIFIED = 0,

  /**
   * The MCP integration is initializing connection
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_INITIALIZING = 10;
   */
  MCP_INTEGRATION_PHASE_INITIALIZING = 10,

  /**
   * The MCP integration is connected and operational
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_READY = 20;
   */
  MCP_INTEGRATION_PHASE_READY = 20,

  /**
   * The MCP integration has failed and requires intervention
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_FAILED = 30;
   */
  MCP_INTEGRATION_PHASE_FAILED = 30,

  /**
   * The MCP integration is unavailable (server down, network issue)
   *
   * @generated from enum value: MCP_INTEGRATION_PHASE_UNAVAILABLE = 40;
   */
  MCP_INTEGRATION_PHASE_UNAVAILABLE = 40,
}
// Retrieve enum metadata with: proto3.getEnumType(MCPIntegrationPhase)
proto3.util.setEnumType(MCPIntegrationPhase, "gitpod.v1.MCPIntegrationPhase", [
  { no: 0, name: "MCP_INTEGRATION_PHASE_UNSPECIFIED" },
  { no: 10, name: "MCP_INTEGRATION_PHASE_INITIALIZING" },
  { no: 20, name: "MCP_INTEGRATION_PHASE_READY" },
  { no: 30, name: "MCP_INTEGRATION_PHASE_FAILED" },
  { no: 40, name: "MCP_INTEGRATION_PHASE_UNAVAILABLE" },
]);

/**
 * PullRequest represents pull request metadata from source control systems.
 * This message is used across workflow triggers, executions, and agent contexts
 * to maintain consistent PR information throughout the system.
 *
 * @generated from message gitpod.v1.PullRequest
 */
export class PullRequest extends Message<PullRequest> {
  /**
   * Unique identifier from the source system (e.g., "123" for GitHub PR #123)
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Pull request title
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * Source branch name (the branch being merged from)
   *
   * @generated from field: string from_branch = 3;
   */
  fromBranch = "";

  /**
   * Target branch name (the branch being merged into)
   *
   * @generated from field: string to_branch = 4;
   */
  toBranch = "";

  /**
   * Pull request URL (e.g., "https://github.com/owner/repo/pull/123")
   *
   * @generated from field: string url = 5;
   */
  url = "";

  /**
   * Author name as provided by the SCM system
   *
   * @generated from field: string author = 6;
   */
  author = "";

  /**
   * @generated from field: gitpod.v1.PullRequest.Repository repository = 7;
   */
  repository?: PullRequest_Repository;

  /**
   * Whether this is a draft pull request
   *
   * @generated from field: bool draft = 8;
   */
  draft = false;

  /**
   * @generated from field: gitpod.v1.PullRequest.State state = 9;
   */
  state = PullRequest_State.UNSPECIFIED;

  constructor(data?: PartialMessage<PullRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PullRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "to_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "repository", kind: "message", T: PullRequest_Repository },
    { no: 8, name: "draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "state", kind: "enum", T: proto3.getEnumType(PullRequest_State) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PullRequest {
    return new PullRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PullRequest {
    return new PullRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PullRequest {
    return new PullRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PullRequest | PlainMessage<PullRequest> | undefined, b: PullRequest | PlainMessage<PullRequest> | undefined): boolean {
    return proto3.util.equals(PullRequest, a, b);
  }
}

/**
 * Current state of the pull request
 *
 * @generated from enum gitpod.v1.PullRequest.State
 */
export enum PullRequest_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: STATE_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: STATE_MERGED = 3;
   */
  MERGED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PullRequest_State)
proto3.util.setEnumType(PullRequest_State, "gitpod.v1.PullRequest.State", [
  { no: 0, name: "STATE_UNSPECIFIED" },
  { no: 1, name: "STATE_OPEN" },
  { no: 2, name: "STATE_CLOSED" },
  { no: 3, name: "STATE_MERGED" },
]);

/**
 * Repository information
 *
 * @generated from message gitpod.v1.PullRequest.Repository
 */
export class PullRequest_Repository extends Message<PullRequest_Repository> {
  /**
   * @generated from field: string clone_url = 1;
   */
  cloneUrl = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string owner = 3;
   */
  owner = "";

  /**
   * @generated from field: string name = 4;
   */
  name = "";

  constructor(data?: PartialMessage<PullRequest_Repository>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PullRequest.Repository";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "clone_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PullRequest_Repository {
    return new PullRequest_Repository().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PullRequest_Repository {
    return new PullRequest_Repository().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PullRequest_Repository {
    return new PullRequest_Repository().fromJsonString(jsonString, options);
  }

  static equals(a: PullRequest_Repository | PlainMessage<PullRequest_Repository> | undefined, b: PullRequest_Repository | PlainMessage<PullRequest_Repository> | undefined): boolean {
    return proto3.util.equals(PullRequest_Repository, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Agent
 */
export class Agent extends Message<Agent> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.AgentMetadata metadata = 2;
   */
  metadata?: AgentMetadata;

  /**
   * @generated from field: gitpod.v1.RunnerSideAgentSpec spec = 3 [deprecated = true];
   * @deprecated
   */
  spec?: RunnerSideAgentSpec;

  /**
   * @generated from oneof gitpod.v1.Agent.agent_spec
   */
  agentSpec: {
    /**
     * @generated from field: gitpod.v1.RunnerSideAgentSpec runner_side = 4;
     */
    value: RunnerSideAgentSpec;
    case: "runnerSide";
  } | {
    /**
     * @generated from field: gitpod.v1.InEnvironmentAgentSpec in_environment = 5;
     */
    value: InEnvironmentAgentSpec;
    case: "inEnvironment";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Agent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Agent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: AgentMetadata },
    { no: 3, name: "spec", kind: "message", T: RunnerSideAgentSpec },
    { no: 4, name: "runner_side", kind: "message", T: RunnerSideAgentSpec, oneof: "agent_spec" },
    { no: 5, name: "in_environment", kind: "message", T: InEnvironmentAgentSpec, oneof: "agent_spec" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Agent {
    return new Agent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Agent {
    return new Agent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Agent {
    return new Agent().fromJsonString(jsonString, options);
  }

  static equals(a: Agent | PlainMessage<Agent> | undefined, b: Agent | PlainMessage<Agent> | undefined): boolean {
    return proto3.util.equals(Agent, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentMetadata
 */
export class AgentMetadata extends Message<AgentMetadata> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<AgentMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentMetadata {
    return new AgentMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentMetadata {
    return new AgentMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentMetadata {
    return new AgentMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: AgentMetadata | PlainMessage<AgentMetadata> | undefined, b: AgentMetadata | PlainMessage<AgentMetadata> | undefined): boolean {
    return proto3.util.equals(AgentMetadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentsRequest
 */
export class ListAgentsRequest extends Message<ListAgentsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListAgentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentsRequest {
    return new ListAgentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentsRequest | PlainMessage<ListAgentsRequest> | undefined, b: ListAgentsRequest | PlainMessage<ListAgentsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentsResponse
 */
export class ListAgentsResponse extends Message<ListAgentsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Agent agents = 2;
   */
  agents: Agent[] = [];

  constructor(data?: PartialMessage<ListAgentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "agents", kind: "message", T: Agent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentsResponse {
    return new ListAgentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentsResponse | PlainMessage<ListAgentsResponse> | undefined, b: ListAgentsResponse | PlainMessage<ListAgentsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentRequest
 */
export class GetAgentRequest extends Message<GetAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  constructor(data?: PartialMessage<GetAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentRequest {
    return new GetAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentRequest | PlainMessage<GetAgentRequest> | undefined, b: GetAgentRequest | PlainMessage<GetAgentRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentResponse
 */
export class GetAgentResponse extends Message<GetAgentResponse> {
  /**
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<GetAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentResponse {
    return new GetAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentResponse | PlainMessage<GetAgentResponse> | undefined, b: GetAgentResponse | PlainMessage<GetAgentResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentCodeContext
 */
export class AgentCodeContext extends Message<AgentCodeContext> {
  /**
   * @generated from oneof gitpod.v1.AgentCodeContext.context
   */
  context: {
    /**
     * @generated from field: string project_id = 1;
     */
    value: string;
    case: "projectId";
  } | {
    /**
     * @generated from field: string environment_id = 2;
     */
    value: string;
    case: "environmentId";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentCodeContext.ContextURL context_url = 3;
     */
    value: AgentCodeContext_ContextURL;
    case: "contextUrl";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * Pull request context - optional metadata about the PR being worked on
   * This is populated when the agent execution is triggered by a PR workflow
   * or when explicitly provided through the browser extension
   *
   * @generated from field: optional gitpod.v1.PullRequest pull_request = 4;
   */
  pullRequest?: PullRequest;

  constructor(data?: PartialMessage<AgentCodeContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentCodeContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "context" },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "context" },
    { no: 3, name: "context_url", kind: "message", T: AgentCodeContext_ContextURL, oneof: "context" },
    { no: 4, name: "pull_request", kind: "message", T: PullRequest, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentCodeContext {
    return new AgentCodeContext().fromJsonString(jsonString, options);
  }

  static equals(a: AgentCodeContext | PlainMessage<AgentCodeContext> | undefined, b: AgentCodeContext | PlainMessage<AgentCodeContext> | undefined): boolean {
    return proto3.util.equals(AgentCodeContext, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentCodeContext.ContextURL
 */
export class AgentCodeContext_ContextURL extends Message<AgentCodeContext_ContextURL> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId = "";

  constructor(data?: PartialMessage<AgentCodeContext_ContextURL>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentCodeContext.ContextURL";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentCodeContext_ContextURL {
    return new AgentCodeContext_ContextURL().fromJsonString(jsonString, options);
  }

  static equals(a: AgentCodeContext_ContextURL | PlainMessage<AgentCodeContext_ContextURL> | undefined, b: AgentCodeContext_ContextURL | PlainMessage<AgentCodeContext_ContextURL> | undefined): boolean {
    return proto3.util.equals(AgentCodeContext_ContextURL, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StartAgentRequest
 */
export class StartAgentRequest extends Message<StartAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 2;
   */
  codeContext?: AgentCodeContext;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * workflow_action_id is an optional reference to the workflow execution action
   * that created this agent execution. Used for tracking and event correlation.
   *
   * @generated from field: optional string workflow_action_id = 4;
   */
  workflowActionId?: string;

  /**
   * mode specifies the operational mode for this agent execution
   * If not specified, defaults to AGENT_MODE_EXECUTION
   *
   * @generated from field: gitpod.v1.AgentMode mode = 5;
   */
  mode = AgentMode.UNSPECIFIED;

  /**
   * runner_id specifies a runner for this agent execution.
   * When set, the agent execution is routed to this runner instead of the
   * runner associated with the environment.
   *
   * @generated from field: string runner_id = 6;
   */
  runnerId = "";

  /**
   * annotations are key-value pairs for tracking external context
   * (e.g., integration session IDs, GitHub issue references).
   * Keys should follow domain/name convention (e.g., "agent-client-session/id").
   *
   * @generated from field: map<string, string> annotations = 7;
   */
  annotations: { [key: string]: string } = {};

  /**
   * session_id is the ID of the session this agent execution belongs to.
   * If empty, a new session is created implicitly.
   *
   * @generated from field: string session_id = 8;
   */
  sessionId = "";

  constructor(data?: PartialMessage<StartAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code_context", kind: "message", T: AgentCodeContext },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "workflow_action_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "mode", kind: "enum", T: proto3.getEnumType(AgentMode) },
    { no: 6, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "annotations", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined, b: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined): boolean {
    return proto3.util.equals(StartAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StartAgentResponse
 */
export class StartAgentResponse extends Message<StartAgentResponse> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<StartAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StartAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined, b: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined): boolean {
    return proto3.util.equals(StartAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest
 */
export class ListAgentExecutionsRequest extends Message<ListAgentExecutionsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListAgentExecutionsRequest.Filter filter = 2;
   */
  filter?: ListAgentExecutionsRequest_Filter;

  constructor(data?: PartialMessage<ListAgentExecutionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListAgentExecutionsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest {
    return new ListAgentExecutionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsRequest | PlainMessage<ListAgentExecutionsRequest> | undefined, b: ListAgentExecutionsRequest | PlainMessage<ListAgentExecutionsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsRequest.Filter
 */
export class ListAgentExecutionsRequest_Filter extends Message<ListAgentExecutionsRequest_Filter> {
  /**
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[] = [];

  /**
   * @generated from field: repeated string project_ids = 2;
   */
  projectIds: string[] = [];

  /**
   * @generated from field: repeated string environment_ids = 3;
   */
  environmentIds: string[] = [];

  /**
   * @generated from field: repeated string creator_ids = 4;
   */
  creatorIds: string[] = [];

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Phase status_phases = 5;
   */
  statusPhases: AgentExecution_Phase[] = [];

  /**
   * @generated from field: repeated gitpod.v1.AgentExecutionRole roles = 6;
   */
  roles: AgentExecutionRole[] = [];

  /**
   * annotations filters by key-value pairs. Only executions containing
   * all specified annotations (with matching values) are returned.
   *
   * @generated from field: map<string, string> annotations = 7;
   */
  annotations: { [key: string]: string } = {};

  /**
   * session_ids filters the response to only executions belonging to the specified sessions
   *
   * @generated from field: repeated string session_ids = 8;
   */
  sessionIds: string[] = [];

  constructor(data?: PartialMessage<ListAgentExecutionsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "environment_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "creator_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "status_phases", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase), repeated: true },
    { no: 6, name: "roles", kind: "enum", T: proto3.getEnumType(AgentExecutionRole), repeated: true },
    { no: 7, name: "annotations", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "session_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsRequest_Filter {
    return new ListAgentExecutionsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsRequest_Filter | PlainMessage<ListAgentExecutionsRequest_Filter> | undefined, b: ListAgentExecutionsRequest_Filter | PlainMessage<ListAgentExecutionsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListAgentExecutionsResponse
 */
export class ListAgentExecutionsResponse extends Message<ListAgentExecutionsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution agent_executions = 2;
   */
  agentExecutions: AgentExecution[] = [];

  constructor(data?: PartialMessage<ListAgentExecutionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListAgentExecutionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "agent_executions", kind: "message", T: AgentExecution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentExecutionsResponse {
    return new ListAgentExecutionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentExecutionsResponse | PlainMessage<ListAgentExecutionsResponse> | undefined, b: ListAgentExecutionsResponse | PlainMessage<ListAgentExecutionsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentExecutionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentExecutionRequest
 */
export class GetAgentExecutionRequest extends Message<GetAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<GetAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentExecutionRequest {
    return new GetAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentExecutionRequest | PlainMessage<GetAgentExecutionRequest> | undefined, b: GetAgentExecutionRequest | PlainMessage<GetAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetAgentExecutionResponse
 */
export class GetAgentExecutionResponse extends Message<GetAgentExecutionResponse> {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  constructor(data?: PartialMessage<GetAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: AgentExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentExecutionResponse {
    return new GetAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentExecutionResponse | PlainMessage<GetAgentExecutionResponse> | undefined, b: GetAgentExecutionResponse | PlainMessage<GetAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionRequest
 */
export class DeleteAgentExecutionRequest extends Message<DeleteAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<DeleteAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentExecutionRequest {
    return new DeleteAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentExecutionRequest | PlainMessage<DeleteAgentExecutionRequest> | undefined, b: DeleteAgentExecutionRequest | PlainMessage<DeleteAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentExecutionResponse
 */
export class DeleteAgentExecutionResponse extends Message<DeleteAgentExecutionResponse> {
  constructor(data?: PartialMessage<DeleteAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentExecutionResponse {
    return new DeleteAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentExecutionResponse | PlainMessage<DeleteAgentExecutionResponse> | undefined, b: DeleteAgentExecutionResponse | PlainMessage<DeleteAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution
 */
export class AgentExecution extends Message<AgentExecution> {
  /**
   * ID is a unique identifier of this agent run. No other agent run with the
   * same name must be managed by this agent manager
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Metadata is data associated with this agent that's required for other
   * parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.AgentExecution.Metadata metadata = 2;
   */
  metadata?: AgentExecution_Metadata;

  /**
   * Spec is the configuration of the agent that's required for the
   * runner to start the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Spec spec = 3;
   */
  spec?: AgentExecution_Spec;

  /**
   * Status is the current status of the agent
   *
   * @generated from field: gitpod.v1.AgentExecution.Status status = 4;
   */
  status?: AgentExecution_Status;

  constructor(data?: PartialMessage<AgentExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: AgentExecution_Metadata },
    { no: 3, name: "spec", kind: "message", T: AgentExecution_Spec },
    { no: 4, name: "status", kind: "message", T: AgentExecution_Status },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution {
    return new AgentExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution {
    return new AgentExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution {
    return new AgentExecution().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution | PlainMessage<AgentExecution> | undefined, b: AgentExecution | PlainMessage<AgentExecution> | undefined): boolean {
    return proto3.util.equals(AgentExecution, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentExecution.Phase
 */
export enum AgentExecution_Phase {
  /**
   * The phase is not set.
   *
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The agent run is pending.
   *
   * @generated from enum value: PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * The agent run is active.
   *
   * @generated from enum value: PHASE_RUNNING = 20;
   */
  RUNNING = 20,

  /**
   * The agent run is waiting for input.
   *
   * @generated from enum value: PHASE_WAITING_FOR_INPUT = 30;
   */
  WAITING_FOR_INPUT = 30,

  /**
   * The agent run is inactive.
   *
   * @generated from enum value: PHASE_STOPPED = 40;
   */
  STOPPED = 40,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentExecution_Phase)
proto3.util.setEnumType(AgentExecution_Phase, "gitpod.v1.AgentExecution.Phase", [
  { no: 0, name: "PHASE_UNSPECIFIED" },
  { no: 10, name: "PHASE_PENDING" },
  { no: 20, name: "PHASE_RUNNING" },
  { no: 30, name: "PHASE_WAITING_FOR_INPUT" },
  { no: 40, name: "PHASE_STOPPED" },
]);

/**
 * @generated from message gitpod.v1.AgentExecution.Metadata
 */
export class AgentExecution_Metadata extends Message<AgentExecution_Metadata> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * role is the role of the agent execution
   *
   * @generated from field: gitpod.v1.AgentExecutionRole role = 6;
   */
  role = AgentExecutionRole.UNSPECIFIED;

  /**
   * workflow_action_id is set when this agent execution was created as part of a workflow.
   * Used to correlate agent executions with their parent workflow execution action.
   *
   * @generated from field: optional string workflow_action_id = 7;
   */
  workflowActionId?: string;

  /**
   * annotations are key-value pairs for tracking external context.
   *
   * @generated from field: map<string, string> annotations = 8;
   */
  annotations: { [key: string]: string } = {};

  /**
   * session_id is the ID of the session this agent execution belongs to.
   *
   * @generated from field: string session_id = 9;
   */
  sessionId = "";

  constructor(data?: PartialMessage<AgentExecution_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creator", kind: "message", T: Subject },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "role", kind: "enum", T: proto3.getEnumType(AgentExecutionRole) },
    { no: 7, name: "workflow_action_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "annotations", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 9, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Metadata {
    return new AgentExecution_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Metadata | PlainMessage<AgentExecution_Metadata> | undefined, b: AgentExecution_Metadata | PlainMessage<AgentExecution_Metadata> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Spec
 */
export class AgentExecution_Spec extends Message<AgentExecution_Spec> {
  /**
   * version of the spec. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.spec_version <
   * b.spec_version then a was the spec before b.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion = protoInt64.zero;

  /**
   * @generated from field: string session = 2;
   */
  session = "";

  /**
   * desired_phase is the desired phase of the agent run
   *
   * @generated from field: gitpod.v1.AgentExecution.Phase desired_phase = 3;
   */
  desiredPhase = AgentExecution_Phase.UNSPECIFIED;

  /**
   * @generated from field: string agent_id = 4;
   */
  agentId = "";

  /**
   * @generated from field: gitpod.v1.AgentCodeContext code_context = 5;
   */
  codeContext?: AgentCodeContext;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Spec.Limits limits = 6;
   */
  limits?: AgentExecution_Spec_Limits;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Spec.LoopCondition loop_conditions = 8;
   */
  loopConditions: AgentExecution_Spec_LoopCondition[] = [];

  constructor(data?: PartialMessage<AgentExecution_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spec_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "desired_phase", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase) },
    { no: 4, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "code_context", kind: "message", T: AgentCodeContext },
    { no: 6, name: "limits", kind: "message", T: AgentExecution_Spec_Limits },
    { no: 8, name: "loop_conditions", kind: "message", T: AgentExecution_Spec_LoopCondition, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Spec {
    return new AgentExecution_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Spec | PlainMessage<AgentExecution_Spec> | undefined, b: AgentExecution_Spec | PlainMessage<AgentExecution_Spec> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Spec.Limits
 */
export class AgentExecution_Spec_Limits extends Message<AgentExecution_Spec_Limits> {
  /**
   * @generated from field: int64 max_iterations = 1;
   */
  maxIterations = protoInt64.zero;

  /**
   * @generated from field: int64 max_output_tokens = 2;
   */
  maxOutputTokens = protoInt64.zero;

  /**
   * @generated from field: int64 max_input_tokens = 3;
   */
  maxInputTokens = protoInt64.zero;

  constructor(data?: PartialMessage<AgentExecution_Spec_Limits>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Spec.Limits";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_iterations", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_output_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "max_input_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Spec_Limits {
    return new AgentExecution_Spec_Limits().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Spec_Limits | PlainMessage<AgentExecution_Spec_Limits> | undefined, b: AgentExecution_Spec_Limits | PlainMessage<AgentExecution_Spec_Limits> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Spec_Limits, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Spec.LoopCondition
 */
export class AgentExecution_Spec_LoopCondition extends Message<AgentExecution_Spec_LoopCondition> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string expression = 2;
   */
  expression = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<AgentExecution_Spec_LoopCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Spec.LoopCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Spec_LoopCondition {
    return new AgentExecution_Spec_LoopCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Spec_LoopCondition {
    return new AgentExecution_Spec_LoopCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Spec_LoopCondition {
    return new AgentExecution_Spec_LoopCondition().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Spec_LoopCondition | PlainMessage<AgentExecution_Spec_LoopCondition> | undefined, b: AgentExecution_Spec_LoopCondition | PlainMessage<AgentExecution_Spec_LoopCondition> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Spec_LoopCondition, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status
 */
export class AgentExecution_Status extends Message<AgentExecution_Status> {
  /**
   * version of the status. The value of this field has no semantic
   * meaning (e.g. don't interpret it as as a timestamp),
   * but it can be used to impose a partial order. If a.status_version <
   * b.status_version then a was the status before b.
   *
   * @generated from field: uint64 status_version = 1;
   */
  statusVersion = protoInt64.zero;

  /**
   * @generated from field: string session = 2;
   */
  session = "";

  /**
   * @generated from field: gitpod.v1.AgentExecution.Phase phase = 3;
   */
  phase = AgentExecution_Phase.UNSPECIFIED;

  /**
   * failure_message contains the reason the agent run failed to operate.
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage = "";

  /**
   * warning_message contains warnings, e.g. when the LLM is overloaded.
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage = "";

  /**
   * failure_reason contains a structured reason code for the failure.
   *
   * @generated from field: gitpod.v1.AgentExecutionFailureReason failure_reason = 6;
   */
  failureReason = AgentExecutionFailureReason.UNSPECIFIED;

  /**
   * conversation_url is the URL to the conversation (all messages exchanged between the agent and the user) of the agent run.
   *
   * @generated from field: string conversation_url = 10;
   */
  conversationUrl = "";

  /**
   * transcript_url is the URL to the LLM transcript (all messages exchanged between the agent and the LLM) of the agent run.
   *
   * @generated from field: string transcript_url = 11;
   */
  transcriptUrl = "";

  /**
   * support_bundle_url is the URL to download a diagnostic bundle for this agent execution.
   *
   * @generated from field: string support_bundle_url = 12;
   */
  supportBundleUrl = "";

  /**
   * @generated from field: int64 iterations = 20;
   */
  iterations = protoInt64.zero;

  /**
   * @generated from field: int64 input_tokens_used = 21;
   */
  inputTokensUsed = protoInt64.zero;

  /**
   * @generated from field: int64 output_tokens_used = 22;
   */
  outputTokensUsed = protoInt64.zero;

  /**
   * @generated from field: int64 context_window_length = 23;
   */
  contextWindowLength = protoInt64.zero;

  /**
   * @generated from field: int64 cached_creation_tokens_used = 24;
   */
  cachedCreationTokensUsed = protoInt64.zero;

  /**
   * @generated from field: int64 cached_input_tokens_used = 25;
   */
  cachedInputTokensUsed = protoInt64.zero;

  /**
   * judgement is the judgement of the agent run produced by the judgement prompt.
   *
   * @generated from field: string judgement = 30;
   */
  judgement = "";

  /**
   * current_operation is the current operation of the agent execution.
   *
   * @generated from field: gitpod.v1.AgentExecution.Status.CurrentOperation current_operation = 40;
   */
  currentOperation?: AgentExecution_Status_CurrentOperation;

  /**
   * used_environments is the list of environments that were used by the agent execution.
   *
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.EnvironmentUsage used_environments = 50;
   */
  usedEnvironments: AgentExecution_Status_EnvironmentUsage[] = [];

  /**
   * current_activity is the current activity description of the agent execution.
   *
   * @generated from field: string current_activity = 60;
   */
  currentActivity = "";

  /**
   * outputs is a map of key-value pairs that can be set by the agent during execution.
   * Similar to task execution outputs, but with typed values for structured data.
   *
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> outputs = 70;
   */
  outputs: { [key: string]: AgentExecution_Status_OutputValue } = {};

  /**
   * supported_model is the LLM model being used by the agent execution.
   *
   * @generated from field: gitpod.v1.SupportedModel supported_model = 80;
   */
  supportedModel = SupportedModel.UNSPECIFIED;

  /**
   * mode is the current operational mode of the agent execution.
   * This is set by the agent when entering different modes (e.g., Ralph mode via /ona:ralph command).
   *
   * @generated from field: gitpod.v1.AgentMode mode = 90;
   */
  mode = AgentMode.UNSPECIFIED;

  /**
   * mcp_integration_statuses contains the status of all MCP integrations used by this agent execution
   *
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.MCPIntegrationStatus mcp_integration_statuses = 100;
   */
  mcpIntegrationStatuses: AgentExecution_Status_MCPIntegrationStatus[] = [];

  /**
   * waiting_info is set when phase is PHASE_WAITING_FOR_INPUT and the agent
   * has registered interests (timers, sub-agent completions, user messages).
   *
   * @generated from field: gitpod.v1.AgentExecution.WaitingInfo waiting_info = 110;
   */
  waitingInfo?: AgentExecution_WaitingInfo;

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.Status.LoopConditionResult loop_condition_results = 120;
   */
  loopConditionResults: AgentExecution_Status_LoopConditionResult[] = [];

  constructor(data?: PartialMessage<AgentExecution_Status>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phase", kind: "enum", T: proto3.getEnumType(AgentExecution_Phase) },
    { no: 4, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "failure_reason", kind: "enum", T: proto3.getEnumType(AgentExecutionFailureReason) },
    { no: 10, name: "conversation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "transcript_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "support_bundle_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "iterations", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "input_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "output_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "context_window_length", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 24, name: "cached_creation_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 25, name: "cached_input_tokens_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "judgement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "current_operation", kind: "message", T: AgentExecution_Status_CurrentOperation },
    { no: 50, name: "used_environments", kind: "message", T: AgentExecution_Status_EnvironmentUsage, repeated: true },
    { no: 60, name: "current_activity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 70, name: "outputs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: AgentExecution_Status_OutputValue} },
    { no: 80, name: "supported_model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 90, name: "mode", kind: "enum", T: proto3.getEnumType(AgentMode) },
    { no: 100, name: "mcp_integration_statuses", kind: "message", T: AgentExecution_Status_MCPIntegrationStatus, repeated: true },
    { no: 110, name: "waiting_info", kind: "message", T: AgentExecution_WaitingInfo },
    { no: 120, name: "loop_condition_results", kind: "message", T: AgentExecution_Status_LoopConditionResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status {
    return new AgentExecution_Status().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status | PlainMessage<AgentExecution_Status> | undefined, b: AgentExecution_Status | PlainMessage<AgentExecution_Status> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.ToolUse
 */
export class AgentExecution_Status_ToolUse extends Message<AgentExecution_Status_ToolUse> {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName = "";

  /**
   * @generated from field: bool complete = 2;
   */
  complete = false;

  constructor(data?: PartialMessage<AgentExecution_Status_ToolUse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.ToolUse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tool_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_ToolUse {
    return new AgentExecution_Status_ToolUse().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_ToolUse | PlainMessage<AgentExecution_Status_ToolUse> | undefined, b: AgentExecution_Status_ToolUse | PlainMessage<AgentExecution_Status_ToolUse> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_ToolUse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.LLM
 */
export class AgentExecution_Status_LLM extends Message<AgentExecution_Status_LLM> {
  /**
   * @generated from field: bool complete = 1;
   */
  complete = false;

  constructor(data?: PartialMessage<AgentExecution_Status_LLM>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.LLM";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "complete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_LLM {
    return new AgentExecution_Status_LLM().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_LLM | PlainMessage<AgentExecution_Status_LLM> | undefined, b: AgentExecution_Status_LLM | PlainMessage<AgentExecution_Status_LLM> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_LLM, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.CurrentOperation
 */
export class AgentExecution_Status_CurrentOperation extends Message<AgentExecution_Status_CurrentOperation> {
  /**
   * @generated from field: string session = 1;
   */
  session = "";

  /**
   * retries is the number of times the agent run has retried one or more steps
   *
   * @generated from field: int64 retries = 2;
   */
  retries = protoInt64.zero;

  /**
   * @generated from oneof gitpod.v1.AgentExecution.Status.CurrentOperation.operation
   */
  operation: {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.ToolUse tool_use = 3;
     */
    value: AgentExecution_Status_ToolUse;
    case: "toolUse";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.Status.LLM llm = 4;
     */
    value: AgentExecution_Status_LLM;
    case: "llm";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentExecution_Status_CurrentOperation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.CurrentOperation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "retries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "tool_use", kind: "message", T: AgentExecution_Status_ToolUse, oneof: "operation" },
    { no: 4, name: "llm", kind: "message", T: AgentExecution_Status_LLM, oneof: "operation" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_CurrentOperation {
    return new AgentExecution_Status_CurrentOperation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_CurrentOperation | PlainMessage<AgentExecution_Status_CurrentOperation> | undefined, b: AgentExecution_Status_CurrentOperation | PlainMessage<AgentExecution_Status_CurrentOperation> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_CurrentOperation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.EnvironmentUsage
 */
export class AgentExecution_Status_EnvironmentUsage extends Message<AgentExecution_Status_EnvironmentUsage> {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId = "";

  /**
   * @generated from field: bool created_by_agent = 2;
   */
  createdByAgent = false;

  constructor(data?: PartialMessage<AgentExecution_Status_EnvironmentUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.EnvironmentUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_by_agent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_EnvironmentUsage {
    return new AgentExecution_Status_EnvironmentUsage().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_EnvironmentUsage | PlainMessage<AgentExecution_Status_EnvironmentUsage> | undefined, b: AgentExecution_Status_EnvironmentUsage | PlainMessage<AgentExecution_Status_EnvironmentUsage> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_EnvironmentUsage, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.OutputValue
 */
export class AgentExecution_Status_OutputValue extends Message<AgentExecution_Status_OutputValue> {
  /**
   * @generated from oneof gitpod.v1.AgentExecution.Status.OutputValue.value
   */
  value: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 int_value = 2;
     */
    value: bigint;
    case: "intValue";
  } | {
    /**
     * @generated from field: double float_value = 3;
     */
    value: number;
    case: "floatValue";
  } | {
    /**
     * @generated from field: bool bool_value = 4;
     */
    value: boolean;
    case: "boolValue";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentExecution_Status_OutputValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.OutputValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 2, name: "int_value", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "value" },
    { no: 3, name: "float_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value" },
    { no: 4, name: "bool_value", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_OutputValue {
    return new AgentExecution_Status_OutputValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_OutputValue {
    return new AgentExecution_Status_OutputValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_OutputValue {
    return new AgentExecution_Status_OutputValue().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_OutputValue | PlainMessage<AgentExecution_Status_OutputValue> | undefined, b: AgentExecution_Status_OutputValue | PlainMessage<AgentExecution_Status_OutputValue> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_OutputValue, a, b);
  }
}

/**
 * MCPIntegrationStatus represents the status of a single MCP integration
 * within an agent execution context
 *
 * @generated from message gitpod.v1.AgentExecution.Status.MCPIntegrationStatus
 */
export class AgentExecution_Status_MCPIntegrationStatus extends Message<AgentExecution_Status_MCPIntegrationStatus> {
  /**
   * id is the unique name of the MCP integration
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * name is the unique name of the MCP integration (e.g., "linear", "notion")
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * phase is the current connection/health phase
   *
   * @generated from field: gitpod.v1.MCPIntegrationPhase phase = 3;
   */
  phase = MCPIntegrationPhase.MCP_INTEGRATION_PHASE_UNSPECIFIED;

  /**
   * failure_message contains the reason the MCP integration failed to connect or operate
   *
   * @generated from field: string failure_message = 4;
   */
  failureMessage = "";

  /**
   * warning_message contains warnings (e.g., rate limiting, degraded performance)
   *
   * @generated from field: string warning_message = 5;
   */
  warningMessage = "";

  constructor(data?: PartialMessage<AgentExecution_Status_MCPIntegrationStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.MCPIntegrationStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phase", kind: "enum", T: proto3.getEnumType(MCPIntegrationPhase) },
    { no: 4, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_MCPIntegrationStatus {
    return new AgentExecution_Status_MCPIntegrationStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_MCPIntegrationStatus {
    return new AgentExecution_Status_MCPIntegrationStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_MCPIntegrationStatus {
    return new AgentExecution_Status_MCPIntegrationStatus().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_MCPIntegrationStatus | PlainMessage<AgentExecution_Status_MCPIntegrationStatus> | undefined, b: AgentExecution_Status_MCPIntegrationStatus | PlainMessage<AgentExecution_Status_MCPIntegrationStatus> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_MCPIntegrationStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.Status.LoopConditionResult
 */
export class AgentExecution_Status_LoopConditionResult extends Message<AgentExecution_Status_LoopConditionResult> {
  /**
   * @generated from field: string condition_id = 1;
   */
  conditionId = "";

  /**
   * @generated from field: bool met = 2;
   */
  met = false;

  /**
   * @generated from field: int32 iteration = 3;
   */
  iteration = 0;

  /**
   * @generated from field: google.protobuf.Timestamp last_evaluated_at = 4;
   */
  lastEvaluatedAt?: Timestamp;

  constructor(data?: PartialMessage<AgentExecution_Status_LoopConditionResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.Status.LoopConditionResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "condition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "met", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "iteration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "last_evaluated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_Status_LoopConditionResult {
    return new AgentExecution_Status_LoopConditionResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_Status_LoopConditionResult {
    return new AgentExecution_Status_LoopConditionResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_Status_LoopConditionResult {
    return new AgentExecution_Status_LoopConditionResult().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_Status_LoopConditionResult | PlainMessage<AgentExecution_Status_LoopConditionResult> | undefined, b: AgentExecution_Status_LoopConditionResult | PlainMessage<AgentExecution_Status_LoopConditionResult> | undefined): boolean {
    return proto3.util.equals(AgentExecution_Status_LoopConditionResult, a, b);
  }
}

/**
 * WaitingInfo describes what an agent is waiting for when in PHASE_WAITING_FOR_INPUT.
 *
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo
 */
export class AgentExecution_WaitingInfo extends Message<AgentExecution_WaitingInfo> {
  /**
   * @generated from field: string wait_id = 1;
   */
  waitId = "";

  /**
   * @generated from field: repeated gitpod.v1.AgentExecution.WaitingInfo.Interest interests = 2;
   */
  interests: AgentExecution_WaitingInfo_Interest[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp waiting_since = 3;
   */
  waitingSince?: Timestamp;

  constructor(data?: PartialMessage<AgentExecution_WaitingInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.WaitingInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "wait_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "interests", kind: "message", T: AgentExecution_WaitingInfo_Interest, repeated: true },
    { no: 3, name: "waiting_since", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_WaitingInfo {
    return new AgentExecution_WaitingInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo {
    return new AgentExecution_WaitingInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo {
    return new AgentExecution_WaitingInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_WaitingInfo | PlainMessage<AgentExecution_WaitingInfo> | undefined, b: AgentExecution_WaitingInfo | PlainMessage<AgentExecution_WaitingInfo> | undefined): boolean {
    return proto3.util.equals(AgentExecution_WaitingInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.TimerInterest
 */
export class AgentExecution_WaitingInfo_TimerInterest extends Message<AgentExecution_WaitingInfo_TimerInterest> {
  /**
   * duration is the original duration spec (e.g. "5m"), if interval-based.
   *
   * @generated from field: string duration = 1;
   */
  duration = "";

  /**
   * cron is the cron expression, if cron-based.
   *
   * @generated from field: string cron = 2;
   */
  cron = "";

  /**
   * fires_at is the next fire time.
   *
   * @generated from field: google.protobuf.Timestamp fires_at = 3;
   */
  firesAt?: Timestamp;

  constructor(data?: PartialMessage<AgentExecution_WaitingInfo_TimerInterest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.WaitingInfo.TimerInterest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "duration", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cron", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fires_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_WaitingInfo_TimerInterest {
    return new AgentExecution_WaitingInfo_TimerInterest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_TimerInterest {
    return new AgentExecution_WaitingInfo_TimerInterest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_TimerInterest {
    return new AgentExecution_WaitingInfo_TimerInterest().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_WaitingInfo_TimerInterest | PlainMessage<AgentExecution_WaitingInfo_TimerInterest> | undefined, b: AgentExecution_WaitingInfo_TimerInterest | PlainMessage<AgentExecution_WaitingInfo_TimerInterest> | undefined): boolean {
    return proto3.util.equals(AgentExecution_WaitingInfo_TimerInterest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest
 */
export class AgentExecution_WaitingInfo_SubAgentInterest extends Message<AgentExecution_WaitingInfo_SubAgentInterest> {
  /**
   * @generated from field: string execution_id = 1;
   */
  executionId = "";

  constructor(data?: PartialMessage<AgentExecution_WaitingInfo_SubAgentInterest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_WaitingInfo_SubAgentInterest {
    return new AgentExecution_WaitingInfo_SubAgentInterest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_SubAgentInterest {
    return new AgentExecution_WaitingInfo_SubAgentInterest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_SubAgentInterest {
    return new AgentExecution_WaitingInfo_SubAgentInterest().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_WaitingInfo_SubAgentInterest | PlainMessage<AgentExecution_WaitingInfo_SubAgentInterest> | undefined, b: AgentExecution_WaitingInfo_SubAgentInterest | PlainMessage<AgentExecution_WaitingInfo_SubAgentInterest> | undefined): boolean {
    return proto3.util.equals(AgentExecution_WaitingInfo_SubAgentInterest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest
 */
export class AgentExecution_WaitingInfo_UserMessageInterest extends Message<AgentExecution_WaitingInfo_UserMessageInterest> {
  constructor(data?: PartialMessage<AgentExecution_WaitingInfo_UserMessageInterest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_WaitingInfo_UserMessageInterest {
    return new AgentExecution_WaitingInfo_UserMessageInterest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_UserMessageInterest {
    return new AgentExecution_WaitingInfo_UserMessageInterest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_UserMessageInterest {
    return new AgentExecution_WaitingInfo_UserMessageInterest().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_WaitingInfo_UserMessageInterest | PlainMessage<AgentExecution_WaitingInfo_UserMessageInterest> | undefined, b: AgentExecution_WaitingInfo_UserMessageInterest | PlainMessage<AgentExecution_WaitingInfo_UserMessageInterest> | undefined): boolean {
    return proto3.util.equals(AgentExecution_WaitingInfo_UserMessageInterest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentExecution.WaitingInfo.Interest
 */
export class AgentExecution_WaitingInfo_Interest extends Message<AgentExecution_WaitingInfo_Interest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from oneof gitpod.v1.AgentExecution.WaitingInfo.Interest.interest
   */
  interest: {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.TimerInterest timer = 2;
     */
    value: AgentExecution_WaitingInfo_TimerInterest;
    case: "timer";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.SubAgentInterest sub_agent = 3;
     */
    value: AgentExecution_WaitingInfo_SubAgentInterest;
    case: "subAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentExecution.WaitingInfo.UserMessageInterest user_message = 4;
     */
    value: AgentExecution_WaitingInfo_UserMessageInterest;
    case: "userMessage";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<AgentExecution_WaitingInfo_Interest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentExecution.WaitingInfo.Interest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timer", kind: "message", T: AgentExecution_WaitingInfo_TimerInterest, oneof: "interest" },
    { no: 3, name: "sub_agent", kind: "message", T: AgentExecution_WaitingInfo_SubAgentInterest, oneof: "interest" },
    { no: 4, name: "user_message", kind: "message", T: AgentExecution_WaitingInfo_UserMessageInterest, oneof: "interest" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentExecution_WaitingInfo_Interest {
    return new AgentExecution_WaitingInfo_Interest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_Interest {
    return new AgentExecution_WaitingInfo_Interest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentExecution_WaitingInfo_Interest {
    return new AgentExecution_WaitingInfo_Interest().fromJsonString(jsonString, options);
  }

  static equals(a: AgentExecution_WaitingInfo_Interest | PlainMessage<AgentExecution_WaitingInfo_Interest> | undefined, b: AgentExecution_WaitingInfo_Interest | PlainMessage<AgentExecution_WaitingInfo_Interest> | undefined): boolean {
    return proto3.util.equals(AgentExecution_WaitingInfo_Interest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ClarifyingQuestions
 */
export class ClarifyingQuestions extends Message<ClarifyingQuestions> {
  /**
   * @generated from field: repeated gitpod.v1.ClarifyingQuestions.Question questions = 1;
   */
  questions: ClarifyingQuestions_Question[] = [];

  constructor(data?: PartialMessage<ClarifyingQuestions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ClarifyingQuestions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "questions", kind: "message", T: ClarifyingQuestions_Question, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClarifyingQuestions {
    return new ClarifyingQuestions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClarifyingQuestions {
    return new ClarifyingQuestions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClarifyingQuestions {
    return new ClarifyingQuestions().fromJsonString(jsonString, options);
  }

  static equals(a: ClarifyingQuestions | PlainMessage<ClarifyingQuestions> | undefined, b: ClarifyingQuestions | PlainMessage<ClarifyingQuestions> | undefined): boolean {
    return proto3.util.equals(ClarifyingQuestions, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ClarifyingQuestions.Choice
 */
export class ClarifyingQuestions_Choice extends Message<ClarifyingQuestions_Choice> {
  /**
   * @generated from field: string label = 1;
   */
  label = "";

  /**
   * @generated from field: string text = 2;
   */
  text = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<ClarifyingQuestions_Choice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ClarifyingQuestions.Choice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClarifyingQuestions_Choice {
    return new ClarifyingQuestions_Choice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClarifyingQuestions_Choice {
    return new ClarifyingQuestions_Choice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClarifyingQuestions_Choice {
    return new ClarifyingQuestions_Choice().fromJsonString(jsonString, options);
  }

  static equals(a: ClarifyingQuestions_Choice | PlainMessage<ClarifyingQuestions_Choice> | undefined, b: ClarifyingQuestions_Choice | PlainMessage<ClarifyingQuestions_Choice> | undefined): boolean {
    return proto3.util.equals(ClarifyingQuestions_Choice, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ClarifyingQuestions.Question
 */
export class ClarifyingQuestions_Question extends Message<ClarifyingQuestions_Question> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: string question = 2;
   */
  question = "";

  /**
   * @generated from field: repeated gitpod.v1.ClarifyingQuestions.Choice choices = 3;
   */
  choices: ClarifyingQuestions_Choice[] = [];

  /**
   * @generated from field: bool allow_other = 4;
   */
  allowOther = false;

  constructor(data?: PartialMessage<ClarifyingQuestions_Question>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ClarifyingQuestions.Question";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "choices", kind: "message", T: ClarifyingQuestions_Choice, repeated: true },
    { no: 4, name: "allow_other", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClarifyingQuestions_Question {
    return new ClarifyingQuestions_Question().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClarifyingQuestions_Question {
    return new ClarifyingQuestions_Question().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClarifyingQuestions_Question {
    return new ClarifyingQuestions_Question().fromJsonString(jsonString, options);
  }

  static equals(a: ClarifyingQuestions_Question | PlainMessage<ClarifyingQuestions_Question> | undefined, b: ClarifyingQuestions_Question | PlainMessage<ClarifyingQuestions_Question> | undefined): boolean {
    return proto3.util.equals(ClarifyingQuestions_Question, a, b);
  }
}

/**
 * @generated from message gitpod.v1.NextStepsProposal
 */
export class NextStepsProposal extends Message<NextStepsProposal> {
  /**
   * @generated from field: repeated gitpod.v1.NextStepsProposal.Action actions = 1;
   */
  actions: NextStepsProposal_Action[] = [];

  constructor(data?: PartialMessage<NextStepsProposal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.NextStepsProposal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actions", kind: "message", T: NextStepsProposal_Action, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NextStepsProposal {
    return new NextStepsProposal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NextStepsProposal {
    return new NextStepsProposal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NextStepsProposal {
    return new NextStepsProposal().fromJsonString(jsonString, options);
  }

  static equals(a: NextStepsProposal | PlainMessage<NextStepsProposal> | undefined, b: NextStepsProposal | PlainMessage<NextStepsProposal> | undefined): boolean {
    return proto3.util.equals(NextStepsProposal, a, b);
  }
}

/**
 * @generated from message gitpod.v1.NextStepsProposal.Action
 */
export class NextStepsProposal_Action extends Message<NextStepsProposal_Action> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string prompt = 2;
   */
  prompt = "";

  /**
   * @generated from field: string variant = 3;
   */
  variant = "";

  constructor(data?: PartialMessage<NextStepsProposal_Action>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.NextStepsProposal.Action";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "variant", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NextStepsProposal_Action {
    return new NextStepsProposal_Action().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NextStepsProposal_Action {
    return new NextStepsProposal_Action().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NextStepsProposal_Action {
    return new NextStepsProposal_Action().fromJsonString(jsonString, options);
  }

  static equals(a: NextStepsProposal_Action | PlainMessage<NextStepsProposal_Action> | undefined, b: NextStepsProposal_Action | PlainMessage<NextStepsProposal_Action> | undefined): boolean {
    return proto3.util.equals(NextStepsProposal_Action, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock
 */
export class AgentResponseBlock extends Message<AgentResponseBlock> {
  /**
   * id is the unique identifier of the response block. A conversation can have multiple blocks with the same ID.
   * Clients are expected to use the ID to update or replace a block.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * phase is the phase of the response block indicating how to update the previous output block with the same ID.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.Phase phase = 2;
   */
  phase = AgentResponseBlock_Phase.UNSPECIFIED;

  /**
   * @generated from oneof gitpod.v1.AgentResponseBlock.output
   */
  output: {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.UserInputBlockSeen user_input_seen = 8;
     */
    value: AgentResponseBlock_UserInputBlockSeen;
    case: "userInputSeen";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock user_input = 9;
     */
    value: UserInputBlock;
    case: "userInput";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput text = 10;
     */
    value: AgentResponseBlock_TextOutput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionStarted action_started = 20;
     */
    value: AgentResponseBlock_ActionStarted;
    case: "actionStarted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.ActionCompleted action_completed = 21;
     */
    value: AgentResponseBlock_ActionCompleted;
    case: "actionCompleted";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.FileModification file_modification = 30;
     */
    value: AgentResponseBlock_FileModification;
    case: "fileModification";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.EnvironmentCreation environment_creation = 40;
     */
    value: AgentResponseBlock_EnvironmentCreation;
    case: "environmentCreation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.CodeAnnotation code_annotation = 50;
     */
    value: AgentResponseBlock_CodeAnnotation;
    case: "codeAnnotation";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.HostAuthenticationRequired host_authentication_required = 60;
     */
    value: AgentResponseBlock_HostAuthenticationRequired;
    case: "hostAuthenticationRequired";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TodoGroup todo_group = 65;
     */
    value: AgentResponseBlock_TodoGroup;
    case: "todoGroup";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.TodoItem todo_item = 70;
     */
    value: AgentResponseBlock_TodoItem;
    case: "todoItem";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.Thought thought = 80;
     */
    value: AgentResponseBlock_Thought;
    case: "thought";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.AgentModeChange agent_mode_change = 90;
     */
    value: AgentResponseBlock_AgentModeChange;
    case: "agentModeChange";
  } | {
    /**
     * @generated from field: gitpod.v1.ClarifyingQuestions clarifying_questions = 91;
     */
    value: ClarifyingQuestions;
    case: "clarifyingQuestions";
  } | {
    /**
     * @generated from field: gitpod.v1.NextStepsProposal next_steps_proposal = 92;
     */
    value: NextStepsProposal;
    case: "nextStepsProposal";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentResponseBlock.AvailableCommands available_commands = 93;
     */
    value: AgentResponseBlock_AvailableCommands;
    case: "availableCommands";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * Timestamp when this block was created. Used for debugging and support bundles.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 100;
   */
  createdAt?: Timestamp;

  /**
   * Active todo snapshot group for routing response fragments in snapshot mode.
   *
   * @generated from field: string todo_group_id = 110;
   */
  todoGroupId = "";

  /**
   * Active in-progress todo item for routing response fragments in snapshot mode.
   *
   * @generated from field: string todo_item_id = 111;
   */
  todoItemId = "";

  constructor(data?: PartialMessage<AgentResponseBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phase", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_Phase) },
    { no: 8, name: "user_input_seen", kind: "message", T: AgentResponseBlock_UserInputBlockSeen, oneof: "output" },
    { no: 9, name: "user_input", kind: "message", T: UserInputBlock, oneof: "output" },
    { no: 10, name: "text", kind: "message", T: AgentResponseBlock_TextOutput, oneof: "output" },
    { no: 20, name: "action_started", kind: "message", T: AgentResponseBlock_ActionStarted, oneof: "output" },
    { no: 21, name: "action_completed", kind: "message", T: AgentResponseBlock_ActionCompleted, oneof: "output" },
    { no: 30, name: "file_modification", kind: "message", T: AgentResponseBlock_FileModification, oneof: "output" },
    { no: 40, name: "environment_creation", kind: "message", T: AgentResponseBlock_EnvironmentCreation, oneof: "output" },
    { no: 50, name: "code_annotation", kind: "message", T: AgentResponseBlock_CodeAnnotation, oneof: "output" },
    { no: 60, name: "host_authentication_required", kind: "message", T: AgentResponseBlock_HostAuthenticationRequired, oneof: "output" },
    { no: 65, name: "todo_group", kind: "message", T: AgentResponseBlock_TodoGroup, oneof: "output" },
    { no: 70, name: "todo_item", kind: "message", T: AgentResponseBlock_TodoItem, oneof: "output" },
    { no: 80, name: "thought", kind: "message", T: AgentResponseBlock_Thought, oneof: "output" },
    { no: 90, name: "agent_mode_change", kind: "message", T: AgentResponseBlock_AgentModeChange, oneof: "output" },
    { no: 91, name: "clarifying_questions", kind: "message", T: ClarifyingQuestions, oneof: "output" },
    { no: 92, name: "next_steps_proposal", kind: "message", T: NextStepsProposal, oneof: "output" },
    { no: 93, name: "available_commands", kind: "message", T: AgentResponseBlock_AvailableCommands, oneof: "output" },
    { no: 100, name: "created_at", kind: "message", T: Timestamp },
    { no: 110, name: "todo_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 111, name: "todo_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock {
    return new AgentResponseBlock().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock | PlainMessage<AgentResponseBlock> | undefined, b: AgentResponseBlock | PlainMessage<AgentResponseBlock> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.Phase
 */
export enum AgentResponseBlock_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Update replaces the previous output block with the same ID.
   *
   * @generated from enum value: PHASE_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * Completed indicates that the output block is complete - it overrides any previous output block with the same ID.
   *
   * @generated from enum value: PHASE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Delta indicates that the output block is a delta to the previous output block; append to the previous output block.
   *
   * @generated from enum value: PHASE_DELTA = 3;
   */
  DELTA = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_Phase)
proto3.util.setEnumType(AgentResponseBlock_Phase, "gitpod.v1.AgentResponseBlock.Phase", [
  { no: 0, name: "PHASE_UNSPECIFIED" },
  { no: 1, name: "PHASE_UPDATE" },
  { no: 2, name: "PHASE_COMPLETED" },
  { no: 3, name: "PHASE_DELTA" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TextOutput
 */
export class AgentResponseBlock_TextOutput extends Message<AgentResponseBlock_TextOutput> {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.TextOutput.Type type = 1;
   */
  type = AgentResponseBlock_TextOutput_Type.UNSPECIFIED;

  /**
   * @generated from field: string content = 2;
   */
  content = "";

  /**
   * Sequence ID for deduplication within the same message. Starts from 1, with 0 indicating unset (backwards compatible).
   *
   * @generated from field: uint64 sequence_id = 3;
   */
  sequenceId = protoInt64.zero;

  constructor(data?: PartialMessage<AgentResponseBlock_TextOutput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.TextOutput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_TextOutput_Type) },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sequence_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_TextOutput {
    return new AgentResponseBlock_TextOutput().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_TextOutput | PlainMessage<AgentResponseBlock_TextOutput> | undefined, b: AgentResponseBlock_TextOutput | PlainMessage<AgentResponseBlock_TextOutput> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_TextOutput, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.TextOutput.Type
 */
export enum AgentResponseBlock_TextOutput_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_USER_FACING_OUTPUT = 1;
   */
  USER_FACING_OUTPUT = 1,

  /**
   * @generated from enum value: TYPE_THOUGHTS = 2;
   */
  THOUGHTS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_TextOutput_Type)
proto3.util.setEnumType(AgentResponseBlock_TextOutput_Type, "gitpod.v1.AgentResponseBlock.TextOutput.Type", [
  { no: 0, name: "TYPE_UNSPECIFIED" },
  { no: 1, name: "TYPE_USER_FACING_OUTPUT" },
  { no: 2, name: "TYPE_THOUGHTS" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionStarted
 */
export class AgentResponseBlock_ActionStarted extends Message<AgentResponseBlock_ActionStarted> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string intent_description = 2;
   */
  intentDescription = "";

  constructor(data?: PartialMessage<AgentResponseBlock_ActionStarted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.ActionStarted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "intent_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionStarted {
    return new AgentResponseBlock_ActionStarted().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_ActionStarted | PlainMessage<AgentResponseBlock_ActionStarted> | undefined, b: AgentResponseBlock_ActionStarted | PlainMessage<AgentResponseBlock_ActionStarted> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_ActionStarted, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.ActionCompleted
 */
export class AgentResponseBlock_ActionCompleted extends Message<AgentResponseBlock_ActionCompleted> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string result_description = 2;
   */
  resultDescription = "";

  /**
   * @generated from field: bool failed = 3;
   */
  failed = false;

  constructor(data?: PartialMessage<AgentResponseBlock_ActionCompleted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.ActionCompleted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "result_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "failed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_ActionCompleted {
    return new AgentResponseBlock_ActionCompleted().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_ActionCompleted | PlainMessage<AgentResponseBlock_ActionCompleted> | undefined, b: AgentResponseBlock_ActionCompleted | PlainMessage<AgentResponseBlock_ActionCompleted> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_ActionCompleted, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification
 */
export class AgentResponseBlock_FileModification extends Message<AgentResponseBlock_FileModification> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string file_path = 2;
   */
  filePath = "";

  /**
   * Legacy SEARCH/REPLACE format content (deprecated in favor of diff)
   *
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: int32 start_line = 4;
   */
  startLine = 0;

  /**
   * Enhanced diff format for dashboard consumption.
   * When present, the dashboard will use this instead of parsing the content field.
   * This provides better performance and more accurate diff rendering.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.Diff diff = 5;
   */
  diff?: AgentResponseBlock_FileModification_Diff;

  constructor(data?: PartialMessage<AgentResponseBlock_FileModification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.FileModification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "diff", kind: "message", T: AgentResponseBlock_FileModification_Diff },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification {
    return new AgentResponseBlock_FileModification().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_FileModification | PlainMessage<AgentResponseBlock_FileModification> | undefined, b: AgentResponseBlock_FileModification | PlainMessage<AgentResponseBlock_FileModification> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_FileModification, a, b);
  }
}

/**
 * DiffGroup represents a contiguous block of lines with the same change type
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.DiffGroup
 */
export class AgentResponseBlock_FileModification_DiffGroup extends Message<AgentResponseBlock_FileModification_DiffGroup> {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type type = 1;
   */
  type = AgentResponseBlock_FileModification_DiffGroup_Type.UNSPECIFIED;

  /**
   * The actual lines of code for this group
   *
   * @generated from field: repeated string lines = 2;
   */
  lines: string[] = [];

  constructor(data?: PartialMessage<AgentResponseBlock_FileModification_DiffGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.FileModification.DiffGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_FileModification_DiffGroup_Type) },
    { no: 2, name: "lines", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_FileModification_DiffGroup {
    return new AgentResponseBlock_FileModification_DiffGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_DiffGroup {
    return new AgentResponseBlock_FileModification_DiffGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_DiffGroup {
    return new AgentResponseBlock_FileModification_DiffGroup().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_FileModification_DiffGroup | PlainMessage<AgentResponseBlock_FileModification_DiffGroup> | undefined, b: AgentResponseBlock_FileModification_DiffGroup | PlainMessage<AgentResponseBlock_FileModification_DiffGroup> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_FileModification_DiffGroup, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type
 */
export enum AgentResponseBlock_FileModification_DiffGroup_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Lines that were added in the new version
   *
   * @generated from enum value: TYPE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * Lines that were removed from the old version
   *
   * @generated from enum value: TYPE_REMOVED = 2;
   */
  REMOVED = 2,

  /**
   * Lines that remain unchanged between versions
   *
   * @generated from enum value: TYPE_UNCHANGED = 3;
   */
  UNCHANGED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_FileModification_DiffGroup_Type)
proto3.util.setEnumType(AgentResponseBlock_FileModification_DiffGroup_Type, "gitpod.v1.AgentResponseBlock.FileModification.DiffGroup.Type", [
  { no: 0, name: "TYPE_UNSPECIFIED" },
  { no: 1, name: "TYPE_ADDED" },
  { no: 2, name: "TYPE_REMOVED" },
  { no: 3, name: "TYPE_UNCHANGED" },
]);

/**
 * Statistics about the changes in the diff
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.DiffStats
 */
export class AgentResponseBlock_FileModification_DiffStats extends Message<AgentResponseBlock_FileModification_DiffStats> {
  /**
   * Number of lines added
   *
   * @generated from field: int32 additions = 1;
   */
  additions = 0;

  /**
   * Number of lines deleted
   *
   * @generated from field: int32 deletions = 2;
   */
  deletions = 0;

  constructor(data?: PartialMessage<AgentResponseBlock_FileModification_DiffStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.FileModification.DiffStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "additions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "deletions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_FileModification_DiffStats {
    return new AgentResponseBlock_FileModification_DiffStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_DiffStats {
    return new AgentResponseBlock_FileModification_DiffStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_DiffStats {
    return new AgentResponseBlock_FileModification_DiffStats().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_FileModification_DiffStats | PlainMessage<AgentResponseBlock_FileModification_DiffStats> | undefined, b: AgentResponseBlock_FileModification_DiffStats | PlainMessage<AgentResponseBlock_FileModification_DiffStats> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_FileModification_DiffStats, a, b);
  }
}

/**
 * Diff provides a structured diff format optimized for dashboard consumption.
 * This format allows the dashboard to render diffs efficiently without parsing
 * the legacy SEARCH/REPLACE format in the content field.
 *
 * @generated from message gitpod.v1.AgentResponseBlock.FileModification.Diff
 */
export class AgentResponseBlock_FileModification_Diff extends Message<AgentResponseBlock_FileModification_Diff> {
  /**
   * Structured diff groups for efficient rendering
   *
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.FileModification.DiffGroup diff_groups = 1;
   */
  diffGroups: AgentResponseBlock_FileModification_DiffGroup[] = [];

  /**
   * Summary statistics for the diff
   *
   * @generated from field: gitpod.v1.AgentResponseBlock.FileModification.DiffStats stats = 2;
   */
  stats?: AgentResponseBlock_FileModification_DiffStats;

  constructor(data?: PartialMessage<AgentResponseBlock_FileModification_Diff>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.FileModification.Diff";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "diff_groups", kind: "message", T: AgentResponseBlock_FileModification_DiffGroup, repeated: true },
    { no: 2, name: "stats", kind: "message", T: AgentResponseBlock_FileModification_DiffStats },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_FileModification_Diff {
    return new AgentResponseBlock_FileModification_Diff().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_Diff {
    return new AgentResponseBlock_FileModification_Diff().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_FileModification_Diff {
    return new AgentResponseBlock_FileModification_Diff().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_FileModification_Diff | PlainMessage<AgentResponseBlock_FileModification_Diff> | undefined, b: AgentResponseBlock_FileModification_Diff | PlainMessage<AgentResponseBlock_FileModification_Diff> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_FileModification_Diff, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.EnvironmentCreation
 */
export class AgentResponseBlock_EnvironmentCreation extends Message<AgentResponseBlock_EnvironmentCreation> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  constructor(data?: PartialMessage<AgentResponseBlock_EnvironmentCreation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.EnvironmentCreation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_EnvironmentCreation {
    return new AgentResponseBlock_EnvironmentCreation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_EnvironmentCreation | PlainMessage<AgentResponseBlock_EnvironmentCreation> | undefined, b: AgentResponseBlock_EnvironmentCreation | PlainMessage<AgentResponseBlock_EnvironmentCreation> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_EnvironmentCreation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.HostAuthenticationRequired
 */
export class AgentResponseBlock_HostAuthenticationRequired extends Message<AgentResponseBlock_HostAuthenticationRequired> {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string runner_id = 3;
   */
  runnerId = "";

  constructor(data?: PartialMessage<AgentResponseBlock_HostAuthenticationRequired>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.HostAuthenticationRequired";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_HostAuthenticationRequired {
    return new AgentResponseBlock_HostAuthenticationRequired().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_HostAuthenticationRequired | PlainMessage<AgentResponseBlock_HostAuthenticationRequired> | undefined, b: AgentResponseBlock_HostAuthenticationRequired | PlainMessage<AgentResponseBlock_HostAuthenticationRequired> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_HostAuthenticationRequired, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.CodeAnnotation
 */
export class AgentResponseBlock_CodeAnnotation extends Message<AgentResponseBlock_CodeAnnotation> {
  /**
   * @generated from field: string file_path = 1;
   */
  filePath = "";

  /**
   * @generated from field: int32 start_line = 2;
   */
  startLine = 0;

  /**
   * @generated from field: int32 end_line = 3;
   */
  endLine = 0;

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: string title = 5;
   */
  title = "";

  constructor(data?: PartialMessage<AgentResponseBlock_CodeAnnotation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.CodeAnnotation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "end_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_CodeAnnotation {
    return new AgentResponseBlock_CodeAnnotation().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_CodeAnnotation | PlainMessage<AgentResponseBlock_CodeAnnotation> | undefined, b: AgentResponseBlock_CodeAnnotation | PlainMessage<AgentResponseBlock_CodeAnnotation> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_CodeAnnotation, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TodoGroup
 */
export class AgentResponseBlock_TodoGroup extends Message<AgentResponseBlock_TodoGroup> {
  /**
   * Agent-controlled identifier for snapshot replacement semantics.
   *
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * Timestamp of the latest snapshot update.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;

  /**
   * Complete todo snapshot for this group.
   *
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.TodoItem todos = 3;
   */
  todos: AgentResponseBlock_TodoItem[] = [];

  constructor(data?: PartialMessage<AgentResponseBlock_TodoGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.TodoGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "updated_at", kind: "message", T: Timestamp },
    { no: 3, name: "todos", kind: "message", T: AgentResponseBlock_TodoItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_TodoGroup {
    return new AgentResponseBlock_TodoGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_TodoGroup {
    return new AgentResponseBlock_TodoGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_TodoGroup {
    return new AgentResponseBlock_TodoGroup().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_TodoGroup | PlainMessage<AgentResponseBlock_TodoGroup> | undefined, b: AgentResponseBlock_TodoGroup | PlainMessage<AgentResponseBlock_TodoGroup> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_TodoGroup, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.TodoItem
 */
export class AgentResponseBlock_TodoItem extends Message<AgentResponseBlock_TodoItem> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.TodoItem.Phase phase = 3;
   */
  phase = AgentResponseBlock_TodoItem_Phase.UNSPECIFIED;

  constructor(data?: PartialMessage<AgentResponseBlock_TodoItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.TodoItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "phase", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_TodoItem_Phase) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_TodoItem {
    return new AgentResponseBlock_TodoItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_TodoItem {
    return new AgentResponseBlock_TodoItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_TodoItem {
    return new AgentResponseBlock_TodoItem().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_TodoItem | PlainMessage<AgentResponseBlock_TodoItem> | undefined, b: AgentResponseBlock_TodoItem | PlainMessage<AgentResponseBlock_TodoItem> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_TodoItem, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.TodoItem.Phase
 */
export enum AgentResponseBlock_TodoItem_Phase {
  /**
   * @generated from enum value: PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PHASE_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: PHASE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: PHASE_CLEARED = 4;
   */
  CLEARED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_TodoItem_Phase)
proto3.util.setEnumType(AgentResponseBlock_TodoItem_Phase, "gitpod.v1.AgentResponseBlock.TodoItem.Phase", [
  { no: 0, name: "PHASE_UNSPECIFIED" },
  { no: 1, name: "PHASE_PENDING" },
  { no: 2, name: "PHASE_IN_PROGRESS" },
  { no: 3, name: "PHASE_DONE" },
  { no: 4, name: "PHASE_CLEARED" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.Thought
 */
export class AgentResponseBlock_Thought extends Message<AgentResponseBlock_Thought> {
  /**
   * @generated from field: string content = 1;
   */
  content = "";

  constructor(data?: PartialMessage<AgentResponseBlock_Thought>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.Thought";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_Thought {
    return new AgentResponseBlock_Thought().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_Thought {
    return new AgentResponseBlock_Thought().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_Thought {
    return new AgentResponseBlock_Thought().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_Thought | PlainMessage<AgentResponseBlock_Thought> | undefined, b: AgentResponseBlock_Thought | PlainMessage<AgentResponseBlock_Thought> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_Thought, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.UserInputBlockSeen
 */
export class AgentResponseBlock_UserInputBlockSeen extends Message<AgentResponseBlock_UserInputBlockSeen> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<AgentResponseBlock_UserInputBlockSeen>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.UserInputBlockSeen";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_UserInputBlockSeen {
    return new AgentResponseBlock_UserInputBlockSeen().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_UserInputBlockSeen {
    return new AgentResponseBlock_UserInputBlockSeen().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_UserInputBlockSeen {
    return new AgentResponseBlock_UserInputBlockSeen().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_UserInputBlockSeen | PlainMessage<AgentResponseBlock_UserInputBlockSeen> | undefined, b: AgentResponseBlock_UserInputBlockSeen | PlainMessage<AgentResponseBlock_UserInputBlockSeen> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_UserInputBlockSeen, a, b);
  }
}

/**
 * AgentModeChange signals a mode transition in autonomous agent modes (e.g., Ralph mode).
 * This provides structured signaling instead of parsing magic tokens from text output.
 *
 * @generated from message gitpod.v1.AgentResponseBlock.AgentModeChange
 */
export class AgentResponseBlock_AgentModeChange extends Message<AgentResponseBlock_AgentModeChange> {
  /**
   * @generated from field: gitpod.v1.AgentResponseBlock.AgentModeChange.State state = 1;
   */
  state = AgentResponseBlock_AgentModeChange_State.UNSPECIFIED;

  /**
   * Human-readable message describing the mode change
   *
   * @generated from field: string message = 2;
   */
  message = "";

  constructor(data?: PartialMessage<AgentResponseBlock_AgentModeChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.AgentModeChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(AgentResponseBlock_AgentModeChange_State) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_AgentModeChange {
    return new AgentResponseBlock_AgentModeChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_AgentModeChange {
    return new AgentResponseBlock_AgentModeChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_AgentModeChange {
    return new AgentResponseBlock_AgentModeChange().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_AgentModeChange | PlainMessage<AgentResponseBlock_AgentModeChange> | undefined, b: AgentResponseBlock_AgentModeChange | PlainMessage<AgentResponseBlock_AgentModeChange> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_AgentModeChange, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentResponseBlock.AgentModeChange.State
 */
export enum AgentResponseBlock_AgentModeChange_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Spec is complete, transitioning to implementation phase (Ralph mode)
   *
   * @generated from enum value: STATE_SPEC_COMPLETE = 1;
   */
  SPEC_COMPLETE = 1,

  /**
   * Implementation iteration complete, more work needed
   *
   * @generated from enum value: STATE_ITERATION_COMPLETE = 2;
   */
  ITERATION_COMPLETE = 2,

  /**
   * Autonomous mode fully complete
   *
   * @generated from enum value: STATE_COMPLETE = 3;
   */
  COMPLETE = 3,

  /**
   * Spec mode complete, transitioning to normal interactive mode
   *
   * @generated from enum value: STATE_ONA_SPEC_COMPLETE = 4;
   */
  ONA_SPEC_COMPLETE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentResponseBlock_AgentModeChange_State)
proto3.util.setEnumType(AgentResponseBlock_AgentModeChange_State, "gitpod.v1.AgentResponseBlock.AgentModeChange.State", [
  { no: 0, name: "STATE_UNSPECIFIED" },
  { no: 1, name: "STATE_SPEC_COMPLETE" },
  { no: 2, name: "STATE_ITERATION_COMPLETE" },
  { no: 3, name: "STATE_COMPLETE" },
  { no: 4, name: "STATE_ONA_SPEC_COMPLETE" },
]);

/**
 * @generated from message gitpod.v1.AgentResponseBlock.AvailableCommand
 */
export class AgentResponseBlock_AvailableCommand extends Message<AgentResponseBlock_AvailableCommand> {
  /**
   * The command name without the leading slash (e.g., "go-tests", "create-pr")
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Human-readable description of what the command does
   *
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<AgentResponseBlock_AvailableCommand>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.AvailableCommand";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_AvailableCommand {
    return new AgentResponseBlock_AvailableCommand().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_AvailableCommand {
    return new AgentResponseBlock_AvailableCommand().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_AvailableCommand {
    return new AgentResponseBlock_AvailableCommand().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_AvailableCommand | PlainMessage<AgentResponseBlock_AvailableCommand> | undefined, b: AgentResponseBlock_AvailableCommand | PlainMessage<AgentResponseBlock_AvailableCommand> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_AvailableCommand, a, b);
  }
}

/**
 * @generated from message gitpod.v1.AgentResponseBlock.AvailableCommands
 */
export class AgentResponseBlock_AvailableCommands extends Message<AgentResponseBlock_AvailableCommands> {
  /**
   * @generated from field: repeated gitpod.v1.AgentResponseBlock.AvailableCommand commands = 1;
   */
  commands: AgentResponseBlock_AvailableCommand[] = [];

  constructor(data?: PartialMessage<AgentResponseBlock_AvailableCommands>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentResponseBlock.AvailableCommands";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "commands", kind: "message", T: AgentResponseBlock_AvailableCommand, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentResponseBlock_AvailableCommands {
    return new AgentResponseBlock_AvailableCommands().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentResponseBlock_AvailableCommands {
    return new AgentResponseBlock_AvailableCommands().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentResponseBlock_AvailableCommands {
    return new AgentResponseBlock_AvailableCommands().fromJsonString(jsonString, options);
  }

  static equals(a: AgentResponseBlock_AvailableCommands | PlainMessage<AgentResponseBlock_AvailableCommands> | undefined, b: AgentResponseBlock_AvailableCommands | PlainMessage<AgentResponseBlock_AvailableCommands> | undefined): boolean {
    return proto3.util.equals(AgentResponseBlock_AvailableCommands, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UserInputBlock
 */
export class UserInputBlock extends Message<UserInputBlock> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from oneof gitpod.v1.UserInputBlock.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.TextInput text = 20 [deprecated = true];
     * @deprecated
     */
    value: UserInputBlock_TextInput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.ImageInput image = 21 [deprecated = true];
     * @deprecated
     */
    value: UserInputBlock_ImageInput;
    case: "image";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: repeated gitpod.v1.UserInputBlock.Input inputs = 30;
   */
  inputs: UserInputBlock_Input[] = [];

  /**
   * Timestamp when this block was created. Used for debugging and support bundles.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 100;
   */
  createdAt?: Timestamp;

  constructor(data?: PartialMessage<UserInputBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "text", kind: "message", T: UserInputBlock_TextInput, oneof: "input" },
    { no: 21, name: "image", kind: "message", T: UserInputBlock_ImageInput, oneof: "input" },
    { no: 30, name: "inputs", kind: "message", T: UserInputBlock_Input, repeated: true },
    { no: 100, name: "created_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock {
    return new UserInputBlock().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock {
    return new UserInputBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock {
    return new UserInputBlock().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock | PlainMessage<UserInputBlock> | undefined, b: UserInputBlock | PlainMessage<UserInputBlock> | undefined): boolean {
    return proto3.util.equals(UserInputBlock, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UserInputBlock.TextInput
 */
export class UserInputBlock_TextInput extends Message<UserInputBlock_TextInput> {
  /**
   * @generated from field: string content = 1;
   */
  content = "";

  constructor(data?: PartialMessage<UserInputBlock_TextInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock.TextInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock_TextInput {
    return new UserInputBlock_TextInput().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock_TextInput | PlainMessage<UserInputBlock_TextInput> | undefined, b: UserInputBlock_TextInput | PlainMessage<UserInputBlock_TextInput> | undefined): boolean {
    return proto3.util.equals(UserInputBlock_TextInput, a, b);
  }
}

/**
 * ImageInput allows sending images to the agent.
 * Client must provide the MIME type; backend validates against magic bytes.
 *
 * @generated from message gitpod.v1.UserInputBlock.ImageInput
 */
export class UserInputBlock_ImageInput extends Message<UserInputBlock_ImageInput> {
  /**
   * Raw image data (max 4MB). Supported formats: PNG, JPEG.
   *
   * @generated from field: bytes data = 1;
   */
  data = new Uint8Array(0);

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType = "";

  /**
   * Content-addressed reference to offloaded image data.
   * Set by the runner when storing in the conversation store; data is cleared.
   * Clients never send this field.
   *
   * @generated from field: string data_ref = 3;
   */
  dataRef = "";

  constructor(data?: PartialMessage<UserInputBlock_ImageInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock.ImageInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock_ImageInput {
    return new UserInputBlock_ImageInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock_ImageInput {
    return new UserInputBlock_ImageInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock_ImageInput {
    return new UserInputBlock_ImageInput().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock_ImageInput | PlainMessage<UserInputBlock_ImageInput> | undefined, b: UserInputBlock_ImageInput | PlainMessage<UserInputBlock_ImageInput> | undefined): boolean {
    return proto3.util.equals(UserInputBlock_ImageInput, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UserInputBlock.Input
 */
export class UserInputBlock_Input extends Message<UserInputBlock_Input> {
  /**
   * @generated from oneof gitpod.v1.UserInputBlock.Input.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.TextInput text = 20;
     */
    value: UserInputBlock_TextInput;
    case: "text";
  } | {
    /**
     * @generated from field: gitpod.v1.UserInputBlock.ImageInput image = 21;
     */
    value: UserInputBlock_ImageInput;
    case: "image";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UserInputBlock_Input>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UserInputBlock.Input";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 20, name: "text", kind: "message", T: UserInputBlock_TextInput, oneof: "input" },
    { no: 21, name: "image", kind: "message", T: UserInputBlock_ImageInput, oneof: "input" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInputBlock_Input {
    return new UserInputBlock_Input().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInputBlock_Input {
    return new UserInputBlock_Input().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInputBlock_Input {
    return new UserInputBlock_Input().fromJsonString(jsonString, options);
  }

  static equals(a: UserInputBlock_Input | PlainMessage<UserInputBlock_Input> | undefined, b: UserInputBlock_Input | PlainMessage<UserInputBlock_Input> | undefined): boolean {
    return proto3.util.equals(UserInputBlock_Input, a, b);
  }
}

/**
 * AgentMessage is a message sent between agents (e.g. from a parent agent to a
 * child agent execution, or vice versa).
 *
 * @generated from message gitpod.v1.AgentMessage
 */
export class AgentMessage extends Message<AgentMessage> {
  /**
   * @generated from field: gitpod.v1.AgentMessage.Type type = 1;
   */
  type = AgentMessage_Type.UNSPECIFIED;

  /**
   * Free-form payload of the message.
   *
   * @generated from field: string payload = 2;
   */
  payload = "";

  /**
   * The role of the sender in the agent hierarchy.
   *
   * @generated from field: gitpod.v1.AgentMessage.Role role = 3;
   */
  role = AgentMessage_Role.UNSPECIFIED;

  /**
   * The execution ID of the agent that sent this message.
   *
   * @generated from field: string sender_execution_id = 4;
   */
  senderExecutionId = "";

  constructor(data?: PartialMessage<AgentMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.AgentMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(AgentMessage_Type) },
    { no: 2, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(AgentMessage_Role) },
    { no: 4, name: "sender_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentMessage {
    return new AgentMessage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentMessage {
    return new AgentMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentMessage {
    return new AgentMessage().fromJsonString(jsonString, options);
  }

  static equals(a: AgentMessage | PlainMessage<AgentMessage> | undefined, b: AgentMessage | PlainMessage<AgentMessage> | undefined): boolean {
    return proto3.util.equals(AgentMessage, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.AgentMessage.Type
 */
export enum AgentMessage_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Regular inter-agent update message.
   *
   * @generated from enum value: TYPE_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * Signals that the sending agent has completed its task.
   *
   * @generated from enum value: TYPE_COMPLETE = 2;
   */
  COMPLETE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentMessage_Type)
proto3.util.setEnumType(AgentMessage_Type, "gitpod.v1.AgentMessage.Type", [
  { no: 0, name: "TYPE_UNSPECIFIED" },
  { no: 1, name: "TYPE_UPDATE" },
  { no: 2, name: "TYPE_COMPLETE" },
]);

/**
 * Role identifies the sender's relationship in the parent/child hierarchy.
 *
 * @generated from enum gitpod.v1.AgentMessage.Role
 */
export enum AgentMessage_Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The sender is the parent agent.
   *
   * @generated from enum value: ROLE_PARENT = 1;
   */
  PARENT = 1,

  /**
   * The sender is a child (sub-agent).
   *
   * @generated from enum value: ROLE_CHILD = 2;
   */
  CHILD = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(AgentMessage_Role)
proto3.util.setEnumType(AgentMessage_Role, "gitpod.v1.AgentMessage.Role", [
  { no: 0, name: "ROLE_UNSPECIFIED" },
  { no: 1, name: "ROLE_PARENT" },
  { no: 2, name: "ROLE_CHILD" },
]);

/**
 * WakeEvent is sent by the backend to wake an agent when a registered interest fires.
 * Delivered via SendToAgentExecution as a new oneof variant.
 *
 * @generated from message gitpod.v1.WakeEvent
 */
export class WakeEvent extends Message<WakeEvent> {
  /**
   * The interest ID that fired (from WaitingInfo.Interest.id).
   *
   * @generated from field: string interest_id = 1;
   */
  interestId = "";

  /**
   * Interest-specific payload describing what fired.
   *
   * @generated from oneof gitpod.v1.WakeEvent.payload
   */
  payload: {
    /**
     * @generated from field: gitpod.v1.WakeEvent.TimerFired timer = 2;
     */
    value: WakeEvent_TimerFired;
    case: "timer";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent.LoopRetrigger loop_retrigger = 3;
     */
    value: WakeEvent_LoopRetrigger;
    case: "loopRetrigger";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<WakeEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WakeEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "interest_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timer", kind: "message", T: WakeEvent_TimerFired, oneof: "payload" },
    { no: 3, name: "loop_retrigger", kind: "message", T: WakeEvent_LoopRetrigger, oneof: "payload" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WakeEvent {
    return new WakeEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WakeEvent {
    return new WakeEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WakeEvent {
    return new WakeEvent().fromJsonString(jsonString, options);
  }

  static equals(a: WakeEvent | PlainMessage<WakeEvent> | undefined, b: WakeEvent | PlainMessage<WakeEvent> | undefined): boolean {
    return proto3.util.equals(WakeEvent, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WakeEvent.TimerFired
 */
export class WakeEvent_TimerFired extends Message<WakeEvent_TimerFired> {
  /**
   * The actual time the timer was evaluated as expired.
   *
   * @generated from field: google.protobuf.Timestamp fired_at = 1;
   */
  firedAt?: Timestamp;

  constructor(data?: PartialMessage<WakeEvent_TimerFired>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WakeEvent.TimerFired";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fired_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WakeEvent_TimerFired {
    return new WakeEvent_TimerFired().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WakeEvent_TimerFired {
    return new WakeEvent_TimerFired().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WakeEvent_TimerFired {
    return new WakeEvent_TimerFired().fromJsonString(jsonString, options);
  }

  static equals(a: WakeEvent_TimerFired | PlainMessage<WakeEvent_TimerFired> | undefined, b: WakeEvent_TimerFired | PlainMessage<WakeEvent_TimerFired> | undefined): boolean {
    return proto3.util.equals(WakeEvent_TimerFired, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WakeEvent.LoopRetrigger
 */
export class WakeEvent_LoopRetrigger extends Message<WakeEvent_LoopRetrigger> {
  /**
   * @generated from field: repeated gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition unmet_conditions = 1;
   */
  unmetConditions: WakeEvent_LoopRetrigger_UnmetCondition[] = [];

  /**
   * @generated from field: map<string, string> outputs = 2;
   */
  outputs: { [key: string]: string } = {};

  constructor(data?: PartialMessage<WakeEvent_LoopRetrigger>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WakeEvent.LoopRetrigger";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unmet_conditions", kind: "message", T: WakeEvent_LoopRetrigger_UnmetCondition, repeated: true },
    { no: 2, name: "outputs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WakeEvent_LoopRetrigger {
    return new WakeEvent_LoopRetrigger().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WakeEvent_LoopRetrigger {
    return new WakeEvent_LoopRetrigger().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WakeEvent_LoopRetrigger {
    return new WakeEvent_LoopRetrigger().fromJsonString(jsonString, options);
  }

  static equals(a: WakeEvent_LoopRetrigger | PlainMessage<WakeEvent_LoopRetrigger> | undefined, b: WakeEvent_LoopRetrigger | PlainMessage<WakeEvent_LoopRetrigger> | undefined): boolean {
    return proto3.util.equals(WakeEvent_LoopRetrigger, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition
 */
export class WakeEvent_LoopRetrigger_UnmetCondition extends Message<WakeEvent_LoopRetrigger_UnmetCondition> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string expression = 2;
   */
  expression = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: int32 iteration = 4;
   */
  iteration = 0;

  /**
   * @generated from field: int32 max_iterations = 5;
   */
  maxIterations = 0;

  /**
   * @generated from field: string reason = 6;
   */
  reason = "";

  constructor(data?: PartialMessage<WakeEvent_LoopRetrigger_UnmetCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WakeEvent.LoopRetrigger.UnmetCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "iteration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "max_iterations", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WakeEvent_LoopRetrigger_UnmetCondition {
    return new WakeEvent_LoopRetrigger_UnmetCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WakeEvent_LoopRetrigger_UnmetCondition {
    return new WakeEvent_LoopRetrigger_UnmetCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WakeEvent_LoopRetrigger_UnmetCondition {
    return new WakeEvent_LoopRetrigger_UnmetCondition().fromJsonString(jsonString, options);
  }

  static equals(a: WakeEvent_LoopRetrigger_UnmetCondition | PlainMessage<WakeEvent_LoopRetrigger_UnmetCondition> | undefined, b: WakeEvent_LoopRetrigger_UnmetCondition | PlainMessage<WakeEvent_LoopRetrigger_UnmetCondition> | undefined): boolean {
    return proto3.util.equals(WakeEvent_LoopRetrigger_UnmetCondition, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendToAgentExecutionRequest
 */
export class SendToAgentExecutionRequest extends Message<SendToAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * @generated from oneof gitpod.v1.SendToAgentExecutionRequest.input
   */
  input: {
    /**
     * @generated from field: gitpod.v1.UserInputBlock user_input = 2;
     */
    value: UserInputBlock;
    case: "userInput";
  } | {
    /**
     * @generated from field: gitpod.v1.AgentMessage agent_message = 3;
     */
    value: AgentMessage;
    case: "agentMessage";
  } | {
    /**
     * @generated from field: gitpod.v1.WakeEvent wake_event = 4;
     */
    value: WakeEvent;
    case: "wakeEvent";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SendToAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendToAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_input", kind: "message", T: UserInputBlock, oneof: "input" },
    { no: 3, name: "agent_message", kind: "message", T: AgentMessage, oneof: "input" },
    { no: 4, name: "wake_event", kind: "message", T: WakeEvent, oneof: "input" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToAgentExecutionRequest {
    return new SendToAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendToAgentExecutionRequest | PlainMessage<SendToAgentExecutionRequest> | undefined, b: SendToAgentExecutionRequest | PlainMessage<SendToAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(SendToAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendToAgentExecutionResponse
 */
export class SendToAgentExecutionResponse extends Message<SendToAgentExecutionResponse> {
  constructor(data?: PartialMessage<SendToAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendToAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendToAgentExecutionResponse {
    return new SendToAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendToAgentExecutionResponse | PlainMessage<SendToAgentExecutionResponse> | undefined, b: SendToAgentExecutionResponse | PlainMessage<SendToAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(SendToAgentExecutionResponse, a, b);
  }
}

/**
 * PromptValidationErrorDetails is returned as an error detail on INVALID_ARGUMENT
 * when a prompt contains deceptive Unicode characters (e.g. bidi overrides).
 * The frontend uses this to offer a one-click fix.
 *
 * @generated from message gitpod.v1.PromptValidationErrorDetails
 */
export class PromptValidationErrorDetails extends Message<PromptValidationErrorDetails> {
  /**
   * The prompt content with deceptive characters removed.
   *
   * @generated from field: string cleaned_text = 1;
   */
  cleanedText = "";

  /**
   * The number of deceptive characters that were removed.
   *
   * @generated from field: int32 removed_count = 2;
   */
  removedCount = 0;

  constructor(data?: PartialMessage<PromptValidationErrorDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PromptValidationErrorDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cleaned_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "removed_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PromptValidationErrorDetails {
    return new PromptValidationErrorDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PromptValidationErrorDetails {
    return new PromptValidationErrorDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PromptValidationErrorDetails {
    return new PromptValidationErrorDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PromptValidationErrorDetails | PlainMessage<PromptValidationErrorDetails> | undefined, b: PromptValidationErrorDetails | PlainMessage<PromptValidationErrorDetails> | undefined): boolean {
    return proto3.util.equals(PromptValidationErrorDetails, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenRequest
 */
export class CreateAgentExecutionConversationTokenRequest extends Message<CreateAgentExecutionConversationTokenRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<CreateAgentExecutionConversationTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionConversationTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenRequest {
    return new CreateAgentExecutionConversationTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionConversationTokenRequest | PlainMessage<CreateAgentExecutionConversationTokenRequest> | undefined, b: CreateAgentExecutionConversationTokenRequest | PlainMessage<CreateAgentExecutionConversationTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionConversationTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionConversationTokenResponse
 */
export class CreateAgentExecutionConversationTokenResponse extends Message<CreateAgentExecutionConversationTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<CreateAgentExecutionConversationTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionConversationTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionConversationTokenResponse {
    return new CreateAgentExecutionConversationTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionConversationTokenResponse | PlainMessage<CreateAgentExecutionConversationTokenResponse> | undefined, b: CreateAgentExecutionConversationTokenResponse | PlainMessage<CreateAgentExecutionConversationTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionConversationTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenRequest
 */
export class CreateAgentExecutionTranscriptTokenRequest extends Message<CreateAgentExecutionTranscriptTokenRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<CreateAgentExecutionTranscriptTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionTranscriptTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenRequest {
    return new CreateAgentExecutionTranscriptTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionTranscriptTokenRequest | PlainMessage<CreateAgentExecutionTranscriptTokenRequest> | undefined, b: CreateAgentExecutionTranscriptTokenRequest | PlainMessage<CreateAgentExecutionTranscriptTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionTranscriptTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentExecutionTranscriptTokenResponse
 */
export class CreateAgentExecutionTranscriptTokenResponse extends Message<CreateAgentExecutionTranscriptTokenResponse> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<CreateAgentExecutionTranscriptTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentExecutionTranscriptTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentExecutionTranscriptTokenResponse {
    return new CreateAgentExecutionTranscriptTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentExecutionTranscriptTokenResponse | PlainMessage<CreateAgentExecutionTranscriptTokenResponse> | undefined, b: CreateAgentExecutionTranscriptTokenResponse | PlainMessage<CreateAgentExecutionTranscriptTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentExecutionTranscriptTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerSideAgentSpec
 */
export class RunnerSideAgentSpec extends Message<RunnerSideAgentSpec> {
  /**
   * The prompts configuration for each supported model. One cannot have multiple prompts for the same model - this will return an invalid argument error.
   *
   * @generated from field: repeated gitpod.v1.RunnerSideAgentSpec.Prompts prompts = 1;
   */
  prompts: RunnerSideAgentSpec_Prompts[] = [];

  /**
   * The list of tools required by this agent to function
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[] = [];

  /**
   * Ordered list of models the runner should try when creating an LLM client.
   * Populated by the backend based on org tier. If empty, the runner falls
   * back to its built-in PreferredModels list (backward compatibility).
   *
   * @generated from field: repeated gitpod.v1.SupportedModel preferred_models = 3;
   */
  preferredModels: SupportedModel[] = [];

  constructor(data?: PartialMessage<RunnerSideAgentSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerSideAgentSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "message", T: RunnerSideAgentSpec_Prompts, repeated: true },
    { no: 2, name: "required_tools", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "preferred_models", kind: "enum", T: proto3.getEnumType(SupportedModel), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerSideAgentSpec {
    return new RunnerSideAgentSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerSideAgentSpec {
    return new RunnerSideAgentSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerSideAgentSpec {
    return new RunnerSideAgentSpec().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerSideAgentSpec | PlainMessage<RunnerSideAgentSpec> | undefined, b: RunnerSideAgentSpec | PlainMessage<RunnerSideAgentSpec> | undefined): boolean {
    return proto3.util.equals(RunnerSideAgentSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerSideAgentSpec.Prompts
 */
export class RunnerSideAgentSpec_Prompts extends Message<RunnerSideAgentSpec_Prompts> {
  /**
   * The model these prompts are for
   *
   * @generated from field: gitpod.v1.SupportedModel model = 1;
   */
  model = SupportedModel.UNSPECIFIED;

  /**
   * The system prompt that defines the agent's role and capabilities
   *
   * @generated from field: string system_prompt = 2;
   */
  systemPrompt = "";

  /**
   * The initial message sent to the user. If empty, the agent will start in WAITING_FOR_INPUT state
   *
   * @generated from field: string initial_message = 3;
   */
  initialMessage = "";

  /**
   * The prompt used to evaluate agent's performance and provide final assessment
   *
   * @generated from field: string judgement_prompt = 4;
   */
  judgementPrompt = "";

  /**
   * The prompt used to improve the agent's prompt
   *
   * @generated from field: string improve_prompt = 5;
   */
  improvePrompt = "";

  constructor(data?: PartialMessage<RunnerSideAgentSpec_Prompts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerSideAgentSpec.Prompts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 2, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initial_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "judgement_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "improve_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerSideAgentSpec_Prompts {
    return new RunnerSideAgentSpec_Prompts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerSideAgentSpec_Prompts {
    return new RunnerSideAgentSpec_Prompts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerSideAgentSpec_Prompts {
    return new RunnerSideAgentSpec_Prompts().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerSideAgentSpec_Prompts | PlainMessage<RunnerSideAgentSpec_Prompts> | undefined, b: RunnerSideAgentSpec_Prompts | PlainMessage<RunnerSideAgentSpec_Prompts> | undefined): boolean {
    return proto3.util.equals(RunnerSideAgentSpec_Prompts, a, b);
  }
}

/**
 * @generated from message gitpod.v1.InEnvironmentAgentSpec
 */
export class InEnvironmentAgentSpec extends Message<InEnvironmentAgentSpec> {
  /**
   * @generated from field: gitpod.v1.ServiceSpec service = 1;
   */
  service?: ServiceSpec;

  /**
   * The list of models supported by this in-environment agent
   *
   * @generated from field: repeated gitpod.v1.SupportedModel required_models = 2;
   */
  requiredModels: SupportedModel[] = [];

  constructor(data?: PartialMessage<InEnvironmentAgentSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.InEnvironmentAgentSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service", kind: "message", T: ServiceSpec },
    { no: 2, name: "required_models", kind: "enum", T: proto3.getEnumType(SupportedModel), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InEnvironmentAgentSpec {
    return new InEnvironmentAgentSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InEnvironmentAgentSpec {
    return new InEnvironmentAgentSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InEnvironmentAgentSpec {
    return new InEnvironmentAgentSpec().fromJsonString(jsonString, options);
  }

  static equals(a: InEnvironmentAgentSpec | PlainMessage<InEnvironmentAgentSpec> | undefined, b: InEnvironmentAgentSpec | PlainMessage<InEnvironmentAgentSpec> | undefined): boolean {
    return proto3.util.equals(InEnvironmentAgentSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentRequest
 */
export class CreateAgentRequest extends Message<CreateAgentRequest> {
  /**
   * The name of the agent
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * A description of what the agent does
   *
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from oneof gitpod.v1.CreateAgentRequest.spec
   */
  spec: {
    /**
     * @generated from field: gitpod.v1.RunnerSideAgentSpec runner_side = 10;
     */
    value: RunnerSideAgentSpec;
    case: "runnerSide";
  } | {
    /**
     * @generated from field: gitpod.v1.InEnvironmentAgentSpec in_environment = 20;
     */
    value: InEnvironmentAgentSpec;
    case: "inEnvironment";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CreateAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "runner_side", kind: "message", T: RunnerSideAgentSpec, oneof: "spec" },
    { no: 20, name: "in_environment", kind: "message", T: InEnvironmentAgentSpec, oneof: "spec" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentRequest {
    return new CreateAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentRequest | PlainMessage<CreateAgentRequest> | undefined, b: CreateAgentRequest | PlainMessage<CreateAgentRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateAgentResponse
 */
export class CreateAgentResponse extends Message<CreateAgentResponse> {
  /**
   * The created agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<CreateAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentResponse {
    return new CreateAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentResponse | PlainMessage<CreateAgentResponse> | undefined, b: CreateAgentResponse | PlainMessage<CreateAgentResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest
 */
export class UpdateAgentRequest extends Message<UpdateAgentRequest> {
  /**
   * The ID of the agent to update
   *
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * Optional metadata which will replace the existing metadata partially
   * If not provided, the existing metadata will be kept.
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Metadata metadata = 2;
   */
  metadata?: UpdateAgentRequest_Metadata;

  /**
   * Optional spec which will replace the existing spec partially
   *
   * @generated from field: gitpod.v1.UpdateAgentRequest.Spec spec = 3;
   */
  spec?: UpdateAgentRequest_Spec;

  constructor(data?: PartialMessage<UpdateAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: UpdateAgentRequest_Metadata },
    { no: 3, name: "spec", kind: "message", T: UpdateAgentRequest_Spec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest {
    return new UpdateAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest | PlainMessage<UpdateAgentRequest> | undefined, b: UpdateAgentRequest | PlainMessage<UpdateAgentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Metadata
 */
export class UpdateAgentRequest_Metadata extends Message<UpdateAgentRequest_Metadata> {
  /**
   * The name of the agent
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * A description of what the agent does
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateAgentRequest_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Metadata {
    return new UpdateAgentRequest_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest_Metadata | PlainMessage<UpdateAgentRequest_Metadata> | undefined, b: UpdateAgentRequest_Metadata | PlainMessage<UpdateAgentRequest_Metadata> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentRequest.Spec
 */
export class UpdateAgentRequest_Spec extends Message<UpdateAgentRequest_Spec> {
  /**
   * The prompts configuration for each supported model.
   * Setting the system prompt of a model to the empty value will remove the system prompt for that model.
   * Adding a prompt for a model that already has a prompt will replace the existing prompt for that model.
   * Adding a prompt for a model that does not exist adds a new prompt for that model.
   *
   * @generated from field: repeated gitpod.v1.RunnerSideAgentSpec.Prompts prompts = 1;
   */
  prompts: RunnerSideAgentSpec_Prompts[] = [];

  /**
   * The list of tools required by this agent to function.
   * Providing a value here will replace the existing list of required tools.
   *
   * @generated from field: repeated string required_tools = 2;
   */
  requiredTools: string[] = [];

  constructor(data?: PartialMessage<UpdateAgentRequest_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentRequest.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "message", T: RunnerSideAgentSpec_Prompts, repeated: true },
    { no: 2, name: "required_tools", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentRequest_Spec {
    return new UpdateAgentRequest_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentRequest_Spec | PlainMessage<UpdateAgentRequest_Spec> | undefined, b: UpdateAgentRequest_Spec | PlainMessage<UpdateAgentRequest_Spec> | undefined): boolean {
    return proto3.util.equals(UpdateAgentRequest_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentResponse
 */
export class UpdateAgentResponse extends Message<UpdateAgentResponse> {
  /**
   * The updated agent
   *
   * @generated from field: gitpod.v1.Agent agent = 1;
   */
  agent?: Agent;

  constructor(data?: PartialMessage<UpdateAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent", kind: "message", T: Agent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentResponse {
    return new UpdateAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentResponse | PlainMessage<UpdateAgentResponse> | undefined, b: UpdateAgentResponse | PlainMessage<UpdateAgentResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentRequest
 */
export class DeleteAgentRequest extends Message<DeleteAgentRequest> {
  /**
   * The ID of the agent to delete
   *
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  constructor(data?: PartialMessage<DeleteAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentRequest {
    return new DeleteAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentRequest | PlainMessage<DeleteAgentRequest> | undefined, b: DeleteAgentRequest | PlainMessage<DeleteAgentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteAgentResponse
 */
export class DeleteAgentResponse extends Message<DeleteAgentResponse> {
  constructor(data?: PartialMessage<DeleteAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteAgentResponse {
    return new DeleteAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteAgentResponse | PlainMessage<DeleteAgentResponse> | undefined, b: DeleteAgentResponse | PlainMessage<DeleteAgentResponse> | undefined): boolean {
    return proto3.util.equals(DeleteAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StopAgentExecutionRequest
 */
export class StopAgentExecutionRequest extends Message<StopAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<StopAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StopAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopAgentExecutionRequest {
    return new StopAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StopAgentExecutionRequest | PlainMessage<StopAgentExecutionRequest> | undefined, b: StopAgentExecutionRequest | PlainMessage<StopAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(StopAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.StopAgentExecutionResponse
 */
export class StopAgentExecutionResponse extends Message<StopAgentExecutionResponse> {
  constructor(data?: PartialMessage<StopAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.StopAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StopAgentExecutionResponse {
    return new StopAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StopAgentExecutionResponse | PlainMessage<StopAgentExecutionResponse> | undefined, b: StopAgentExecutionResponse | PlainMessage<StopAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(StopAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionRequest
 */
export class UpdateAgentExecutionRequest extends Message<UpdateAgentExecutionRequest> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * Only loop_conditions is used for now.
   *
   * @generated from field: gitpod.v1.AgentExecution.Spec spec = 2;
   */
  spec?: AgentExecution_Spec;

  constructor(data?: PartialMessage<UpdateAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "spec", kind: "message", T: AgentExecution_Spec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentExecutionRequest {
    return new UpdateAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentExecutionRequest {
    return new UpdateAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentExecutionRequest {
    return new UpdateAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentExecutionRequest | PlainMessage<UpdateAgentExecutionRequest> | undefined, b: UpdateAgentExecutionRequest | PlainMessage<UpdateAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateAgentExecutionResponse
 */
export class UpdateAgentExecutionResponse extends Message<UpdateAgentExecutionResponse> {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  constructor(data?: PartialMessage<UpdateAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: AgentExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentExecutionResponse {
    return new UpdateAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentExecutionResponse {
    return new UpdateAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentExecutionResponse {
    return new UpdateAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentExecutionResponse | PlainMessage<UpdateAgentExecutionResponse> | undefined, b: UpdateAgentExecutionResponse | PlainMessage<UpdateAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportAgentExecutionOutputsRequest
 */
export class ReportAgentExecutionOutputsRequest extends Message<ReportAgentExecutionOutputsRequest> {
  /**
   * The ID of the agent execution to report outputs for
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * Outputs to report. New outputs are merged with existing outputs.
   * Values are stored as strings and the API determines the type.
   *
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> outputs = 2;
   */
  outputs: { [key: string]: AgentExecution_Status_OutputValue } = {};

  constructor(data?: PartialMessage<ReportAgentExecutionOutputsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportAgentExecutionOutputsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "outputs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: AgentExecution_Status_OutputValue} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAgentExecutionOutputsRequest {
    return new ReportAgentExecutionOutputsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAgentExecutionOutputsRequest {
    return new ReportAgentExecutionOutputsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAgentExecutionOutputsRequest {
    return new ReportAgentExecutionOutputsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportAgentExecutionOutputsRequest | PlainMessage<ReportAgentExecutionOutputsRequest> | undefined, b: ReportAgentExecutionOutputsRequest | PlainMessage<ReportAgentExecutionOutputsRequest> | undefined): boolean {
    return proto3.util.equals(ReportAgentExecutionOutputsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportAgentExecutionOutputsResponse
 */
export class ReportAgentExecutionOutputsResponse extends Message<ReportAgentExecutionOutputsResponse> {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  constructor(data?: PartialMessage<ReportAgentExecutionOutputsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportAgentExecutionOutputsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: AgentExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAgentExecutionOutputsResponse {
    return new ReportAgentExecutionOutputsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAgentExecutionOutputsResponse {
    return new ReportAgentExecutionOutputsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAgentExecutionOutputsResponse {
    return new ReportAgentExecutionOutputsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportAgentExecutionOutputsResponse | PlainMessage<ReportAgentExecutionOutputsResponse> | undefined, b: ReportAgentExecutionOutputsResponse | PlainMessage<ReportAgentExecutionOutputsResponse> | undefined): boolean {
    return proto3.util.equals(ReportAgentExecutionOutputsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EmitAgentSessionActivityRequest
 */
export class EmitAgentSessionActivityRequest extends Message<EmitAgentSessionActivityRequest> {
  /**
   * The agent execution ID. Used to resolve the organization for auth/token lookup.
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * The external session ID (e.g., Linear agent session ID).
   * The runner resolves this from annotations at startup and passes it directly,
   * avoiding repeated annotation lookups on every emit call.
   *
   * @generated from field: string external_agent_session_id = 2;
   */
  externalAgentSessionId = "";

  /**
   * The structured response block to forward to the external session.
   * The backend type-switches on the block's oneof output to decide how to render.
   *
   * @generated from field: gitpod.v1.AgentResponseBlock response_block = 3;
   */
  responseBlock?: AgentResponseBlock;

  /**
   * The current agent execution status. When present, the backend uses this
   * for phase-specific emissions (thoughts, errors, keepalive, external URLs)
   * instead of relying on the separate status reflection path.
   * This field is optional for backward compatibility.
   *
   * @generated from field: gitpod.v1.AgentExecution.Status status = 4;
   */
  status?: AgentExecution_Status;

  /**
   * Optional next steps proposal from the agent. Reported separately from
   * response_block so integrations can decide whether and how to render it.
   * The Linear integration ignores this; other integrations may render it.
   *
   * @generated from field: gitpod.v1.NextStepsProposal next_steps_proposal = 5;
   */
  nextStepsProposal?: NextStepsProposal;

  constructor(data?: PartialMessage<EmitAgentSessionActivityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EmitAgentSessionActivityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "external_agent_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "response_block", kind: "message", T: AgentResponseBlock },
    { no: 4, name: "status", kind: "message", T: AgentExecution_Status },
    { no: 5, name: "next_steps_proposal", kind: "message", T: NextStepsProposal },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EmitAgentSessionActivityRequest {
    return new EmitAgentSessionActivityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EmitAgentSessionActivityRequest {
    return new EmitAgentSessionActivityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EmitAgentSessionActivityRequest {
    return new EmitAgentSessionActivityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EmitAgentSessionActivityRequest | PlainMessage<EmitAgentSessionActivityRequest> | undefined, b: EmitAgentSessionActivityRequest | PlainMessage<EmitAgentSessionActivityRequest> | undefined): boolean {
    return proto3.util.equals(EmitAgentSessionActivityRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EmitAgentSessionActivityResponse
 */
export class EmitAgentSessionActivityResponse extends Message<EmitAgentSessionActivityResponse> {
  constructor(data?: PartialMessage<EmitAgentSessionActivityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EmitAgentSessionActivityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EmitAgentSessionActivityResponse {
    return new EmitAgentSessionActivityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EmitAgentSessionActivityResponse {
    return new EmitAgentSessionActivityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EmitAgentSessionActivityResponse {
    return new EmitAgentSessionActivityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EmitAgentSessionActivityResponse | PlainMessage<EmitAgentSessionActivityResponse> | undefined, b: EmitAgentSessionActivityResponse | PlainMessage<EmitAgentSessionActivityResponse> | undefined): boolean {
    return proto3.util.equals(EmitAgentSessionActivityResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentRequest
 */
export class ImprovePromptForAgentRequest extends Message<ImprovePromptForAgentRequest> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * @generated from field: string prompt = 2;
   */
  prompt = "";

  constructor(data?: PartialMessage<ImprovePromptForAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ImprovePromptForAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImprovePromptForAgentRequest {
    return new ImprovePromptForAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImprovePromptForAgentRequest | PlainMessage<ImprovePromptForAgentRequest> | undefined, b: ImprovePromptForAgentRequest | PlainMessage<ImprovePromptForAgentRequest> | undefined): boolean {
    return proto3.util.equals(ImprovePromptForAgentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ImprovePromptForAgentResponse
 */
export class ImprovePromptForAgentResponse extends Message<ImprovePromptForAgentResponse> {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt = "";

  constructor(data?: PartialMessage<ImprovePromptForAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ImprovePromptForAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "improved_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImprovePromptForAgentResponse {
    return new ImprovePromptForAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImprovePromptForAgentResponse | PlainMessage<ImprovePromptForAgentResponse> | undefined, b: ImprovePromptForAgentResponse | PlainMessage<ImprovePromptForAgentResponse> | undefined): boolean {
    return proto3.util.equals(ImprovePromptForAgentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateLLMAccessTokenRequest
 */
export class CreateLLMAccessTokenRequest extends Message<CreateLLMAccessTokenRequest> {
  /**
   * The models required by the agent to function.
   *
   * @generated from field: repeated gitpod.v1.SupportedModel required_models = 1;
   */
  requiredModels: SupportedModel[] = [];

  /**
   * The agent execution ID for tracking and runner selection.
   * If empty, falls back to current logic for backward compatibility.
   *
   * @generated from field: string agent_execution_id = 3;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<CreateLLMAccessTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateLLMAccessTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "required_models", kind: "enum", T: proto3.getEnumType(SupportedModel), repeated: true },
    { no: 3, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLLMAccessTokenRequest {
    return new CreateLLMAccessTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLLMAccessTokenRequest {
    return new CreateLLMAccessTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLLMAccessTokenRequest {
    return new CreateLLMAccessTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLLMAccessTokenRequest | PlainMessage<CreateLLMAccessTokenRequest> | undefined, b: CreateLLMAccessTokenRequest | PlainMessage<CreateLLMAccessTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateLLMAccessTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateLLMAccessTokenResponse
 */
export class CreateLLMAccessTokenResponse extends Message<CreateLLMAccessTokenResponse> {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  /**
   * @generated from field: string llm_url = 2;
   */
  llmUrl = "";

  constructor(data?: PartialMessage<CreateLLMAccessTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateLLMAccessTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "llm_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLLMAccessTokenResponse {
    return new CreateLLMAccessTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLLMAccessTokenResponse {
    return new CreateLLMAccessTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLLMAccessTokenResponse {
    return new CreateLLMAccessTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLLMAccessTokenResponse | PlainMessage<CreateLLMAccessTokenResponse> | undefined, b: CreateLLMAccessTokenResponse | PlainMessage<CreateLLMAccessTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateLLMAccessTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.MCPIntegration
 */
export class MCPIntegration extends Message<MCPIntegration> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string url = 3;
   */
  url = "";

  constructor(data?: PartialMessage<MCPIntegration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.MCPIntegration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MCPIntegration {
    return new MCPIntegration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MCPIntegration {
    return new MCPIntegration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MCPIntegration {
    return new MCPIntegration().fromJsonString(jsonString, options);
  }

  static equals(a: MCPIntegration | PlainMessage<MCPIntegration> | undefined, b: MCPIntegration | PlainMessage<MCPIntegration> | undefined): boolean {
    return proto3.util.equals(MCPIntegration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMCPIntegrationsRequest
 */
export class ListMCPIntegrationsRequest extends Message<ListMCPIntegrationsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<ListMCPIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMCPIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMCPIntegrationsRequest {
    return new ListMCPIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMCPIntegrationsRequest {
    return new ListMCPIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMCPIntegrationsRequest {
    return new ListMCPIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMCPIntegrationsRequest | PlainMessage<ListMCPIntegrationsRequest> | undefined, b: ListMCPIntegrationsRequest | PlainMessage<ListMCPIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(ListMCPIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMCPIntegrationsResponse
 */
export class ListMCPIntegrationsResponse extends Message<ListMCPIntegrationsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.MCPIntegration mcp_integrations = 2;
   */
  mcpIntegrations: MCPIntegration[] = [];

  constructor(data?: PartialMessage<ListMCPIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMCPIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "mcp_integrations", kind: "message", T: MCPIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMCPIntegrationsResponse {
    return new ListMCPIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMCPIntegrationsResponse {
    return new ListMCPIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMCPIntegrationsResponse {
    return new ListMCPIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMCPIntegrationsResponse | PlainMessage<ListMCPIntegrationsResponse> | undefined, b: ListMCPIntegrationsResponse | PlainMessage<ListMCPIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListMCPIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateMCPAccessTokenRequest
 */
export class CreateMCPAccessTokenRequest extends Message<CreateMCPAccessTokenRequest> {
  constructor(data?: PartialMessage<CreateMCPAccessTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateMCPAccessTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMCPAccessTokenRequest {
    return new CreateMCPAccessTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMCPAccessTokenRequest {
    return new CreateMCPAccessTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMCPAccessTokenRequest {
    return new CreateMCPAccessTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMCPAccessTokenRequest | PlainMessage<CreateMCPAccessTokenRequest> | undefined, b: CreateMCPAccessTokenRequest | PlainMessage<CreateMCPAccessTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateMCPAccessTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateMCPAccessTokenResponse
 */
export class CreateMCPAccessTokenResponse extends Message<CreateMCPAccessTokenResponse> {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreateMCPAccessTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateMCPAccessTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMCPAccessTokenResponse {
    return new CreateMCPAccessTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMCPAccessTokenResponse {
    return new CreateMCPAccessTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMCPAccessTokenResponse {
    return new CreateMCPAccessTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMCPAccessTokenResponse | PlainMessage<CreateMCPAccessTokenResponse> | undefined, b: CreateMCPAccessTokenResponse | PlainMessage<CreateMCPAccessTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateMCPAccessTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSearchAccessTokenRequest
 */
export class CreateSearchAccessTokenRequest extends Message<CreateSearchAccessTokenRequest> {
  constructor(data?: PartialMessage<CreateSearchAccessTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSearchAccessTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSearchAccessTokenRequest {
    return new CreateSearchAccessTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSearchAccessTokenRequest {
    return new CreateSearchAccessTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSearchAccessTokenRequest {
    return new CreateSearchAccessTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSearchAccessTokenRequest | PlainMessage<CreateSearchAccessTokenRequest> | undefined, b: CreateSearchAccessTokenRequest | PlainMessage<CreateSearchAccessTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateSearchAccessTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateSearchAccessTokenResponse
 */
export class CreateSearchAccessTokenResponse extends Message<CreateSearchAccessTokenResponse> {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreateSearchAccessTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateSearchAccessTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSearchAccessTokenResponse {
    return new CreateSearchAccessTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSearchAccessTokenResponse {
    return new CreateSearchAccessTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSearchAccessTokenResponse {
    return new CreateSearchAccessTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSearchAccessTokenResponse | PlainMessage<CreateSearchAccessTokenResponse> | undefined, b: CreateSearchAccessTokenResponse | PlainMessage<CreateSearchAccessTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateSearchAccessTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Prompt
 */
export class Prompt extends Message<Prompt> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gitpod.v1.PromptMetadata metadata = 2;
   */
  metadata?: PromptMetadata;

  /**
   * @generated from field: gitpod.v1.PromptSpec spec = 3;
   */
  spec?: PromptSpec;

  constructor(data?: PartialMessage<Prompt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Prompt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: PromptMetadata },
    { no: 3, name: "spec", kind: "message", T: PromptSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Prompt {
    return new Prompt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Prompt {
    return new Prompt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Prompt {
    return new Prompt().fromJsonString(jsonString, options);
  }

  static equals(a: Prompt | PlainMessage<Prompt> | undefined, b: Prompt | PlainMessage<Prompt> | undefined): boolean {
    return proto3.util.equals(Prompt, a, b);
  }
}

/**
 * @generated from message gitpod.v1.PromptMetadata
 */
export class PromptMetadata extends Message<PromptMetadata> {
  /**
   * organization_id is the ID of the organization that contains the prompt
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * name is the human readable name of the prompt
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * description is a description of what the prompt does
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * creator is the identity of the prompt creator
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<PromptMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PromptMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creator", kind: "message", T: Subject },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PromptMetadata {
    return new PromptMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PromptMetadata {
    return new PromptMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PromptMetadata {
    return new PromptMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: PromptMetadata | PlainMessage<PromptMetadata> | undefined, b: PromptMetadata | PlainMessage<PromptMetadata> | undefined): boolean {
    return proto3.util.equals(PromptMetadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.PromptSpec
 */
export class PromptSpec extends Message<PromptSpec> {
  /**
   * prompt is the content of the prompt
   *
   * @generated from field: string prompt = 1;
   */
  prompt = "";

  /**
   * is_template indicates if this prompt is a template
   *
   * @generated from field: bool is_template = 2;
   */
  isTemplate = false;

  /**
   * is_command indicates if this prompt is a command
   *
   * @generated from field: bool is_command = 3;
   */
  isCommand = false;

  /**
   * command is the unique command string within the organization
   *
   * @generated from field: string command = 4;
   */
  command = "";

  /**
   * is_skill indicates if this prompt is a skill (workflow instructions for agents)
   *
   * @generated from field: bool is_skill = 5;
   */
  isSkill = false;

  constructor(data?: PartialMessage<PromptSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PromptSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_command", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_skill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PromptSpec {
    return new PromptSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PromptSpec {
    return new PromptSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PromptSpec {
    return new PromptSpec().fromJsonString(jsonString, options);
  }

  static equals(a: PromptSpec | PlainMessage<PromptSpec> | undefined, b: PromptSpec | PlainMessage<PromptSpec> | undefined): boolean {
    return proto3.util.equals(PromptSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPromptsRequest
 */
export class ListPromptsRequest extends Message<ListPromptsRequest> {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListPromptsRequest.Filter filter = 2;
   */
  filter?: ListPromptsRequest_Filter;

  constructor(data?: PartialMessage<ListPromptsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPromptsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListPromptsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPromptsRequest {
    return new ListPromptsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPromptsRequest {
    return new ListPromptsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPromptsRequest {
    return new ListPromptsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPromptsRequest | PlainMessage<ListPromptsRequest> | undefined, b: ListPromptsRequest | PlainMessage<ListPromptsRequest> | undefined): boolean {
    return proto3.util.equals(ListPromptsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPromptsRequest.Filter
 */
export class ListPromptsRequest_Filter extends Message<ListPromptsRequest_Filter> {
  /**
   * @generated from field: bool is_template = 1;
   */
  isTemplate = false;

  /**
   * @generated from field: bool is_command = 2;
   */
  isCommand = false;

  /**
   * @generated from field: string command = 3;
   */
  command = "";

  /**
   * @generated from field: string command_prefix = 4;
   */
  commandPrefix = "";

  /**
   * @generated from field: bool is_skill = 5;
   */
  isSkill = false;

  /**
   * exclude_prompt_content omits the large spec.prompt text from the response.
   * Other spec fields (is_template, is_command, command, is_skill) are still returned.
   * Use GetPrompt to retrieve the full prompt content when needed.
   *
   * @generated from field: bool exclude_prompt_content = 6;
   */
  excludePromptContent = false;

  constructor(data?: PartialMessage<ListPromptsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPromptsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_command", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "command_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_skill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "exclude_prompt_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPromptsRequest_Filter {
    return new ListPromptsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPromptsRequest_Filter {
    return new ListPromptsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPromptsRequest_Filter {
    return new ListPromptsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListPromptsRequest_Filter | PlainMessage<ListPromptsRequest_Filter> | undefined, b: ListPromptsRequest_Filter | PlainMessage<ListPromptsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListPromptsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPromptsResponse
 */
export class ListPromptsResponse extends Message<ListPromptsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Prompt prompts = 2;
   */
  prompts: Prompt[] = [];

  constructor(data?: PartialMessage<ListPromptsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPromptsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "prompts", kind: "message", T: Prompt, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPromptsResponse {
    return new ListPromptsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPromptsResponse {
    return new ListPromptsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPromptsResponse {
    return new ListPromptsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPromptsResponse | PlainMessage<ListPromptsResponse> | undefined, b: ListPromptsResponse | PlainMessage<ListPromptsResponse> | undefined): boolean {
    return proto3.util.equals(ListPromptsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetPromptRequest
 */
export class GetPromptRequest extends Message<GetPromptRequest> {
  /**
   * @generated from field: string prompt_id = 1;
   */
  promptId = "";

  constructor(data?: PartialMessage<GetPromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPromptRequest {
    return new GetPromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPromptRequest {
    return new GetPromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPromptRequest {
    return new GetPromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPromptRequest | PlainMessage<GetPromptRequest> | undefined, b: GetPromptRequest | PlainMessage<GetPromptRequest> | undefined): boolean {
    return proto3.util.equals(GetPromptRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetPromptResponse
 */
export class GetPromptResponse extends Message<GetPromptResponse> {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;

  constructor(data?: PartialMessage<GetPromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: Prompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPromptResponse {
    return new GetPromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPromptResponse {
    return new GetPromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPromptResponse {
    return new GetPromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPromptResponse | PlainMessage<GetPromptResponse> | undefined, b: GetPromptResponse | PlainMessage<GetPromptResponse> | undefined): boolean {
    return proto3.util.equals(GetPromptResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreatePromptRequest
 */
export class CreatePromptRequest extends Message<CreatePromptRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string prompt = 3;
   */
  prompt = "";

  /**
   * @generated from field: bool is_template = 4;
   */
  isTemplate = false;

  /**
   * @generated from field: bool is_command = 5;
   */
  isCommand = false;

  /**
   * @generated from field: string command = 6;
   */
  command = "";

  /**
   * @generated from field: bool is_skill = 7;
   */
  isSkill = false;

  constructor(data?: PartialMessage<CreatePromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_command", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_skill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePromptRequest {
    return new CreatePromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePromptRequest {
    return new CreatePromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePromptRequest {
    return new CreatePromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePromptRequest | PlainMessage<CreatePromptRequest> | undefined, b: CreatePromptRequest | PlainMessage<CreatePromptRequest> | undefined): boolean {
    return proto3.util.equals(CreatePromptRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreatePromptResponse
 */
export class CreatePromptResponse extends Message<CreatePromptResponse> {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;

  constructor(data?: PartialMessage<CreatePromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: Prompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePromptResponse {
    return new CreatePromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePromptResponse {
    return new CreatePromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePromptResponse {
    return new CreatePromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePromptResponse | PlainMessage<CreatePromptResponse> | undefined, b: CreatePromptResponse | PlainMessage<CreatePromptResponse> | undefined): boolean {
    return proto3.util.equals(CreatePromptResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdatePromptRequest
 */
export class UpdatePromptRequest extends Message<UpdatePromptRequest> {
  /**
   * The ID of the prompt to update
   *
   * @generated from field: string prompt_id = 1;
   */
  promptId = "";

  /**
   * Metadata updates
   *
   * @generated from field: optional gitpod.v1.UpdatePromptRequest.Metadata metadata = 2;
   */
  metadata?: UpdatePromptRequest_Metadata;

  /**
   * Spec updates
   *
   * @generated from field: optional gitpod.v1.UpdatePromptRequest.Spec spec = 3;
   */
  spec?: UpdatePromptRequest_Spec;

  constructor(data?: PartialMessage<UpdatePromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdatePromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: UpdatePromptRequest_Metadata, opt: true },
    { no: 3, name: "spec", kind: "message", T: UpdatePromptRequest_Spec, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePromptRequest {
    return new UpdatePromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePromptRequest {
    return new UpdatePromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePromptRequest {
    return new UpdatePromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePromptRequest | PlainMessage<UpdatePromptRequest> | undefined, b: UpdatePromptRequest | PlainMessage<UpdatePromptRequest> | undefined): boolean {
    return proto3.util.equals(UpdatePromptRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdatePromptRequest.Metadata
 */
export class UpdatePromptRequest_Metadata extends Message<UpdatePromptRequest_Metadata> {
  /**
   * The name of the prompt
   *
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * A description of what the prompt does
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdatePromptRequest_Metadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdatePromptRequest.Metadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePromptRequest_Metadata {
    return new UpdatePromptRequest_Metadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePromptRequest_Metadata {
    return new UpdatePromptRequest_Metadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePromptRequest_Metadata {
    return new UpdatePromptRequest_Metadata().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePromptRequest_Metadata | PlainMessage<UpdatePromptRequest_Metadata> | undefined, b: UpdatePromptRequest_Metadata | PlainMessage<UpdatePromptRequest_Metadata> | undefined): boolean {
    return proto3.util.equals(UpdatePromptRequest_Metadata, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdatePromptRequest.Spec
 */
export class UpdatePromptRequest_Spec extends Message<UpdatePromptRequest_Spec> {
  /**
   * The prompt content
   *
   * @generated from field: optional string prompt = 1;
   */
  prompt?: string;

  /**
   * Whether this prompt is a template
   *
   * @generated from field: optional bool is_template = 2;
   */
  isTemplate?: boolean;

  /**
   * Whether this prompt is a command
   *
   * @generated from field: optional bool is_command = 3;
   */
  isCommand?: boolean;

  /**
   * The command string (unique within organization)
   *
   * @generated from field: optional string command = 4;
   */
  command?: string;

  /**
   * Whether this prompt is a skill
   *
   * @generated from field: optional bool is_skill = 5;
   */
  isSkill?: boolean;

  constructor(data?: PartialMessage<UpdatePromptRequest_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdatePromptRequest.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "is_command", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "is_skill", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePromptRequest_Spec {
    return new UpdatePromptRequest_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePromptRequest_Spec {
    return new UpdatePromptRequest_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePromptRequest_Spec {
    return new UpdatePromptRequest_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePromptRequest_Spec | PlainMessage<UpdatePromptRequest_Spec> | undefined, b: UpdatePromptRequest_Spec | PlainMessage<UpdatePromptRequest_Spec> | undefined): boolean {
    return proto3.util.equals(UpdatePromptRequest_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdatePromptResponse
 */
export class UpdatePromptResponse extends Message<UpdatePromptResponse> {
  /**
   * @generated from field: gitpod.v1.Prompt prompt = 1;
   */
  prompt?: Prompt;

  constructor(data?: PartialMessage<UpdatePromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdatePromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: Prompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePromptResponse {
    return new UpdatePromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePromptResponse {
    return new UpdatePromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePromptResponse {
    return new UpdatePromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePromptResponse | PlainMessage<UpdatePromptResponse> | undefined, b: UpdatePromptResponse | PlainMessage<UpdatePromptResponse> | undefined): boolean {
    return proto3.util.equals(UpdatePromptResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeletePromptRequest
 */
export class DeletePromptRequest extends Message<DeletePromptRequest> {
  /**
   * @generated from field: string prompt_id = 1;
   */
  promptId = "";

  constructor(data?: PartialMessage<DeletePromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeletePromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePromptRequest {
    return new DeletePromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePromptRequest {
    return new DeletePromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePromptRequest {
    return new DeletePromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePromptRequest | PlainMessage<DeletePromptRequest> | undefined, b: DeletePromptRequest | PlainMessage<DeletePromptRequest> | undefined): boolean {
    return proto3.util.equals(DeletePromptRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeletePromptResponse
 */
export class DeletePromptResponse extends Message<DeletePromptResponse> {
  constructor(data?: PartialMessage<DeletePromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeletePromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePromptResponse {
    return new DeletePromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePromptResponse {
    return new DeletePromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePromptResponse {
    return new DeletePromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePromptResponse | PlainMessage<DeletePromptResponse> | undefined, b: DeletePromptResponse | PlainMessage<DeletePromptResponse> | undefined): boolean {
    return proto3.util.equals(DeletePromptResponse, a, b);
  }
}

